import type { StaticKey, StaticStrings, StaticVars } from "./types";

const en: StaticStrings = {
  useEmailInstead: "Use email instead",
  useMobileInstead: "Use mobile instead",
  emailAddress: "Email address",
  otpHelperEmail: "We'll send a one-time password to this email.",
  changeEmail: "Change Email",
  expandDetails: "Expand {name} details",
  collapseDetails: "Collapse {name} details",
  selectAllFor: "Select all data elements for {name}",
  selectElement: "Select {name}",
  selectElementRequired: "Select {name} (required)",
  required: "required",
  logoAlt: "Logo",
  selectLanguage: "Select language",
  selectLanguageCurrent: "Select language. Current language: {lang}",
  opensInNewTab: "opens in new tab",
  audioStart: "Start audio playback",
  audioPause: "Pause audio playback",
  talkbackStart: "Start Talkback",
  talkbackPause: "Pause Talkback",
  mobileNumber: "Mobile number",
  otpHelper: "We'll send a one-time password to this number.",
  otpSentTo: "OTP sent to",
  changeMobile: "Change Mobile Number",
  enterNDigitOtp: "Enter {count}-digit OTP",
  otpDigit: "OTP digit {index}",
  resendIn: "Resend OTP in {seconds}s",
  sending: "Sending…",
  resendOtp: "Resend OTP",
  getOtp: "Get OTP",
  verifying: "Verifying…",
  verifyOtp: "Verify OTP",
  sendOtp: "Send OTP",
  confirmOtp: "Confirm OTP",
  verifyWithOtp: "Verify with OTP",
  editSelections: "Edit selections",
  otpIncorrect:
    "The verification code you entered is incorrect. Please check and try again.",
  otpExpired: "Your verification code has expired. Please request a new code.",
  otpNotFound: "Verification code not found. Please request a new code.",
  otpVerifyFailed: "Could not verify the OTP. Please try again.",
  otpSendFailed: "Could not send the OTP. Please try again.",
  consentConfirmed: "Consent confirmed",
  recordedUnder: "OTP verified · recorded under {regulation}",
  recordedUnderAt: "OTP verified · recorded under {regulation} at {time}",
  consentReferenceId: "Consent reference id",
  proceed: "Proceed",
  loadingNotice: "Loading notice",
  loadFailedTitle: "Couldn't load the consent notice",
  tryAgain: "Please try again.",
  close: "Close",
};

const hi: StaticStrings = {
  useEmailInstead: "ईमेल इस्तेमाल करें",
  useMobileInstead: "मोबाइल इस्तेमाल करें",
  emailAddress: "ईमेल पता",
  otpHelperEmail: "हम इस ईमेल पर एक वन-टाइम पासवर्ड भेजेंगे.",
  changeEmail: "ईमेल बदलें",
  expandDetails: "{name} का विवरण विस्तृत करें",
  collapseDetails: "{name} का विवरण संक्षिप्त करें",
  selectAllFor: "{name} के लिए सभी डेटा तत्व चुनें",
  selectElement: "{name} चुनें",
  selectElementRequired: "{name} चुनें (आवश्यक)",
  required: "आवश्यक",
  logoAlt: "लोगो",
  selectLanguage: "भाषा चुनें",
  selectLanguageCurrent: "भाषा चुनें. वर्तमान भाषा: {lang}",
  opensInNewTab: "नए टैब में खुलता है",
  audioStart: "ऑडियो प्लेबैक शुरू करें",
  audioPause: "ऑडियो प्लेबैक रोकें",
  talkbackStart: "टॉकबैक शुरू करें",
  talkbackPause: "टॉकबैक रोकें",
  mobileNumber: "मोबाइल नंबर",
  otpHelper: "हम इस नंबर पर एक वन-टाइम पासवर्ड भेजेंगे.",
  otpSentTo: "ओटीपी (OTP) भेजा गया",
  changeMobile: "मोबाइल नंबर बदलें",
  enterNDigitOtp: "{count}-अंकों का ओटीपी (OTP) दर्ज करें",
  otpDigit: "ओटीपी (OTP) अंक {index}",
  resendIn: "{seconds} सेकंड में ओटीपी (OTP) पुनः भेजें",
  sending: "भेजा जा रहा है…",
  resendOtp: "ओटीपी (OTP) पुनः भेजें",
  getOtp: "ओटीपी (OTP) प्राप्त करें",
  verifying: "सत्यापित किया जा रहा है…",
  verifyOtp: "ओटीपी (OTP) सत्यापित करें",
  sendOtp: "ओटीपी (OTP) भेजें",
  confirmOtp: "ओटीपी (OTP) की पुष्टि करें",
  verifyWithOtp: "ओटीपी (OTP) से सत्यापित करें",
  editSelections: "चयन संपादित करें",
  otpIncorrect:
    "आपके द्वारा दर्ज किया गया सत्यापन कोड गलत है. कृपया जाँचें और पुनः प्रयास करें.",
  otpExpired: "आपके सत्यापन कोड की अवधि समाप्त हो गई है. कृपया नया कोड माँगें.",
  otpNotFound: "सत्यापन कोड नहीं मिला. कृपया नया कोड माँगें.",
  otpVerifyFailed: "ओटीपी (OTP) सत्यापित नहीं हो सका. कृपया पुनः प्रयास करें.",
  otpSendFailed: "ओटीपी (OTP) नहीं भेजा जा सका. कृपया पुनः प्रयास करें.",
  consentConfirmed: "सहमति की पुष्टि हुई",
  recordedUnder: "ओटीपी (OTP) सत्यापित · {regulation} के तहत दर्ज किया गया",
  recordedUnderAt:
    "ओटीपी (OTP) सत्यापित · {regulation} के तहत {time} पर दर्ज किया गया",
  consentReferenceId: "सहमति संदर्भ आईडी",
  proceed: "आगे बढ़ें",
  loadingNotice: "नोटिस लोड हो रहा है",
  loadFailedTitle: "सहमति नोटिस लोड नहीं हो सका",
  tryAgain: "कृपया पुनः प्रयास करें.",
  close: "बंद करें",
};

const bn: StaticStrings = {
  useEmailInstead: "ইমেইল ব্যবহার করুন",
  useMobileInstead: "মোবাইল ব্যবহার করুন",
  emailAddress: "ইমেইল ঠিকানা",
  otpHelperEmail: "আমরা এই ইমেইলে একটি ওয়ান-টাইম পাসওয়ার্ড পাঠাব।",
  changeEmail: "ইমেইল পরিবর্তন করুন",
  expandDetails: "{name} এর বিবরণ প্রসারিত করুন",
  collapseDetails: "{name} এর বিবরণ সংকুচিত করুন",
  selectAllFor: "{name} এর জন্য সমস্ত ডেটা উপাদান নির্বাচন করুন",
  selectElement: "{name} নির্বাচন করুন",
  selectElementRequired: "{name} নির্বাচন করুন (আবশ্যক)",
  required: "আবশ্যক",
  logoAlt: "লোগো",
  selectLanguage: "ভাষা নির্বাচন করুন",
  selectLanguageCurrent: "ভাষা নির্বাচন করুন। বর্তমান ভাষা: {lang}",
  opensInNewTab: "নতুন ট্যাবে খোলে",
  audioStart: "অডিও প্লেব্যাক শুরু করুন",
  audioPause: "অডিও প্লেব্যাক বিরতি দিন",
  talkbackStart: "টকব্যাক শুরু করুন",
  talkbackPause: "টকব্যাক বিরতি দিন",
  mobileNumber: "মোবাইল নম্বর",
  otpHelper: "আমরা এই নম্বরে একটি ওয়ান-টাইম পাসওয়ার্ড পাঠাব।",
  otpSentTo: "ওটিপি (OTP) পাঠানো হয়েছে",
  changeMobile: "মোবাইল নম্বর পরিবর্তন করুন",
  enterNDigitOtp: "{count}-সংখ্যার ওটিপি (OTP) লিখুন",
  otpDigit: "ওটিপি (OTP) সংখ্যা {index}",
  resendIn: "{seconds} সেকেন্ডে ওটিপি (OTP) পুনরায় পাঠান",
  sending: "পাঠানো হচ্ছে…",
  resendOtp: "ওটিপি (OTP) পুনরায় পাঠান",
  getOtp: "ওটিপি (OTP) পান",
  verifying: "যাচাই করা হচ্ছে…",
  verifyOtp: "ওটিপি (OTP) যাচাই করুন",
  sendOtp: "ওটিপি (OTP) পাঠান",
  confirmOtp: "ওটিপি (OTP) নিশ্চিত করুন",
  verifyWithOtp: "ওটিপি (OTP) দিয়ে যাচাই করুন",
  editSelections: "নির্বাচন সম্পাদনা করুন",
  otpIncorrect:
    "আপনি যে যাচাইকরণ কোডটি লিখেছেন তা ভুল। অনুগ্রহ করে যাচাই করে আবার চেষ্টা করুন।",
  otpExpired:
    "আপনার যাচাইকরণ কোডের মেয়াদ শেষ হয়ে গেছে। অনুগ্রহ করে একটি নতুন কোড চান।",
  otpNotFound: "যাচাইকরণ কোড পাওয়া যায়নি। অনুগ্রহ করে একটি নতুন কোড চান।",
  otpVerifyFailed:
    "ওটিপি (OTP) যাচাই করা যায়নি। অনুগ্রহ করে আবার চেষ্টা করুন।",
  otpSendFailed: "ওটিপি (OTP) পাঠানো যায়নি। অনুগ্রহ করে আবার চেষ্টা করুন।",
  consentConfirmed: "সম্মতি নিশ্চিত হয়েছে",
  recordedUnder: "ওটিপি (OTP) যাচাই হয়েছে · {regulation} এর অধীনে নথিভুক্ত",
  recordedUnderAt:
    "ওটিপি (OTP) যাচাই হয়েছে · {regulation} এর অধীনে {time} এ নথিভুক্ত",
  consentReferenceId: "সম্মতি রেফারেন্স আইডি",
  proceed: "এগিয়ে যান",
  loadingNotice: "নোটিশ লোড হচ্ছে",
  loadFailedTitle: "সম্মতি নোটিশ লোড করা যায়নি",
  tryAgain: "অনুগ্রহ করে আবার চেষ্টা করুন।",
  close: "বন্ধ করুন",
};

const gu: StaticStrings = {
  useEmailInstead: "ઇમેલ વાપરો",
  useMobileInstead: "મોબાઇલ વાપરો",
  emailAddress: "ઇમેલ સરનામું",
  otpHelperEmail: "અમે આ ઇમેલ પર વન-ટાઇમ પાસવર્ડ મોકલીશું.",
  changeEmail: "ઇમેલ બદલો",
  expandDetails: "{name} ની વિગતો વિસ્તૃત કરો",
  collapseDetails: "{name} ની વિગતો સંકોચો",
  selectAllFor: "{name} માટે બધા ડેટા ઘટકો પસંદ કરો",
  selectElement: "{name} પસંદ કરો",
  selectElementRequired: "{name} પસંદ કરો (આવશ્યક)",
  required: "આવશ્યક",
  logoAlt: "લોગો",
  selectLanguage: "ભાષા પસંદ કરો",
  selectLanguageCurrent: "ભાષા પસંદ કરો. વર્તમાન ભાષા: {lang}",
  opensInNewTab: "નવી ટૅબમાં ખુલે છે",
  audioStart: "ઑડિયો પ્લેબેક શરૂ કરો",
  audioPause: "ઑડિયો પ્લેબેક થોભાવો",
  talkbackStart: "ટૉકબેક શરૂ કરો",
  talkbackPause: "ટૉકબેક થોભાવો",
  mobileNumber: "મોબાઇલ નંબર",
  otpHelper: "અમે આ નંબર પર વન-ટાઇમ પાસવર્ડ મોકલીશું.",
  otpSentTo: "ઓટીપી (OTP) મોકલ્યો",
  changeMobile: "મોબાઇલ નંબર બદલો",
  enterNDigitOtp: "{count}-અંકનો ઓટીપી (OTP) દાખલ કરો",
  otpDigit: "ઓટીપી (OTP) અંક {index}",
  resendIn: "{seconds} સેકન્ડમાં ઓટીપી (OTP) ફરી મોકલો",
  sending: "મોકલી રહ્યું છે…",
  resendOtp: "ઓટીપી (OTP) ફરી મોકલો",
  getOtp: "ઓટીપી (OTP) મેળવો",
  verifying: "ચકાસી રહ્યું છે…",
  verifyOtp: "ઓટીપી (OTP) ચકાસો",
  sendOtp: "ઓટીપી (OTP) મોકલો",
  confirmOtp: "ઓટીપી (OTP) ની પુષ્ટિ કરો",
  verifyWithOtp: "ઓટીપી (OTP) થી ચકાસો",
  editSelections: "પસંદગીઓ સંપાદિત કરો",
  otpIncorrect:
    "તમે દાખલ કરેલ ચકાસણી કોડ ખોટો છે. કૃપા કરીને તપાસો અને ફરી પ્રયાસ કરો.",
  otpExpired: "તમારા ચકાસણી કોડની મુદત પૂરી થઈ ગઈ છે. કૃપા કરીને નવો કોડ માગો.",
  otpNotFound: "ચકાસણી કોડ મળ્યો નથી. કૃપા કરીને નવો કોડ માગો.",
  otpVerifyFailed: "ઓટીપી (OTP) ચકાસી શકાયો નથી. કૃપા કરીને ફરી પ્રયાસ કરો.",
  otpSendFailed: "ઓટીપી (OTP) મોકલી શકાયો નથી. કૃપા કરીને ફરી પ્રયાસ કરો.",
  consentConfirmed: "સંમતિની પુષ્ટિ થઈ",
  recordedUnder: "ઓટીપી (OTP) ચકાસાયું · {regulation} હેઠળ નોંધાયું",
  recordedUnderAt:
    "ઓટીપી (OTP) ચકાસાયું · {regulation} હેઠળ {time} વાગ્યે નોંધાયું",
  consentReferenceId: "સંમતિ સંદર્ભ આઈડી",
  proceed: "આગળ વધો",
  loadingNotice: "નોટિસ લોડ થઈ રહ્યું છે",
  loadFailedTitle: "સંમતિ નોટિસ લોડ થઈ શકી નથી",
  tryAgain: "કૃપા કરીને ફરી પ્રયાસ કરો.",
  close: "બંધ કરો",
};

const kn: StaticStrings = {
  useEmailInstead: "ಇಮೇಲ್ ಬಳಸಿ",
  useMobileInstead: "ಮೊಬೈಲ್ ಬಳಸಿ",
  emailAddress: "ಇಮೇಲ್ ವಿಳಾಸ",
  otpHelperEmail: "ನಾವು ಈ ಇಮೇಲ್‌ಗೆ ಒಂದು-ಬಾರಿಯ ಪಾಸ್‌ವರ್ಡ್ ಕಳುಹಿಸುತ್ತೇವೆ.",
  changeEmail: "ಇಮೇಲ್ ಬದಲಾಯಿಸಿ",
  expandDetails: "{name} ವಿವರಗಳನ್ನು ವಿಸ್ತರಿಸಿ",
  collapseDetails: "{name} ವಿವರಗಳನ್ನು ಸಂಕುಚಿಸಿ",
  selectAllFor: "{name} ಗಾಗಿ ಎಲ್ಲಾ ಡೇಟಾ ಅಂಶಗಳನ್ನು ಆಯ್ಕೆಮಾಡಿ",
  selectElement: "{name} ಆಯ್ಕೆಮಾಡಿ",
  selectElementRequired: "{name} ಆಯ್ಕೆಮಾಡಿ (ಅಗತ್ಯ)",
  required: "ಅಗತ್ಯ",
  logoAlt: "ಲೋಗೋ",
  selectLanguage: "ಭಾಷೆ ಆಯ್ಕೆಮಾಡಿ",
  selectLanguageCurrent: "ಭಾಷೆ ಆಯ್ಕೆಮಾಡಿ. ಪ್ರಸ್ತುತ ಭಾಷೆ: {lang}",
  opensInNewTab: "ಹೊಸ ಟ್ಯಾಬ್‌ನಲ್ಲಿ ತೆರೆಯುತ್ತದೆ",
  audioStart: "ಆಡಿಯೊ ಪ್ಲೇಬ್ಯಾಕ್ ಪ್ರಾರಂಭಿಸಿ",
  audioPause: "ಆಡಿಯೊ ಪ್ಲೇಬ್ಯಾಕ್ ವಿರಾಮಗೊಳಿಸಿ",
  talkbackStart: "ಟಾಕ್‌ಬ್ಯಾಕ್ ಪ್ರಾರಂಭಿಸಿ",
  talkbackPause: "ಟಾಕ್‌ಬ್ಯಾಕ್ ವಿರಾಮಗೊಳಿಸಿ",
  mobileNumber: "ಮೊಬೈಲ್ ಸಂಖ್ಯೆ",
  otpHelper: "ನಾವು ಈ ಸಂಖ್ಯೆಗೆ ಒಂದು-ಬಾರಿಯ ಪಾಸ್‌ವರ್ಡ್ ಕಳುಹಿಸುತ್ತೇವೆ.",
  otpSentTo: "ಓಟಿಪಿ (OTP) ಕಳುಹಿಸಲಾಗಿದೆ",
  changeMobile: "ಮೊಬೈಲ್ ಸಂಖ್ಯೆ ಬದಲಾಯಿಸಿ",
  enterNDigitOtp: "{count}-ಅಂಕಿಯ ಓಟಿಪಿ (OTP) ನಮೂದಿಸಿ",
  otpDigit: "ಓಟಿಪಿ (OTP) ಅಂಕಿ {index}",
  resendIn: "{seconds} ಸೆಕೆಂಡುಗಳಲ್ಲಿ ಓಟಿಪಿ (OTP) ಮರುಕಳುಹಿಸಿ",
  sending: "ಕಳುಹಿಸಲಾಗುತ್ತಿದೆ…",
  resendOtp: "ಓಟಿಪಿ (OTP) ಮರುಕಳುಹಿಸಿ",
  getOtp: "ಓಟಿಪಿ (OTP) ಪಡೆಯಿರಿ",
  verifying: "ಪರಿಶೀಲಿಸಲಾಗುತ್ತಿದೆ…",
  verifyOtp: "ಓಟಿಪಿ (OTP) ಪರಿಶೀಲಿಸಿ",
  sendOtp: "ಓಟಿಪಿ (OTP) ಕಳುಹಿಸಿ",
  confirmOtp: "ಓಟಿಪಿ (OTP) ದೃಢೀಕರಿಸಿ",
  verifyWithOtp: "ಓಟಿಪಿ (OTP) ಮೂಲಕ ಪರಿಶೀಲಿಸಿ",
  editSelections: "ಆಯ್ಕೆಗಳನ್ನು ಸಂಪಾದಿಸಿ",
  otpIncorrect:
    "ನೀವು ನಮೂದಿಸಿದ ಪರಿಶೀಲನಾ ಕೋಡ್ ತಪ್ಪಾಗಿದೆ. ದಯವಿಟ್ಟು ಪರಿಶೀಲಿಸಿ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
  otpExpired: "ನಿಮ್ಮ ಪರಿಶೀಲನಾ ಕೋಡ್ ಅವಧಿ ಮೀರಿದೆ. ದಯವಿಟ್ಟು ಹೊಸ ಕೋಡ್ ಕೋರಿ.",
  otpNotFound: "ಪರಿಶೀಲನಾ ಕೋಡ್ ಕಂಡುಬಂದಿಲ್ಲ. ದಯವಿಟ್ಟು ಹೊಸ ಕೋಡ್ ಕೋರಿ.",
  otpVerifyFailed: "ಓಟಿಪಿ (OTP) ಪರಿಶೀಲಿಸಲಾಗಲಿಲ್ಲ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
  otpSendFailed: "ಓಟಿಪಿ (OTP) ಕಳುಹಿಸಲಾಗಲಿಲ್ಲ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
  consentConfirmed: "ಸಮ್ಮತಿ ದೃಢೀಕರಿಸಲಾಗಿದೆ",
  recordedUnder:
    "ಓಟಿಪಿ (OTP) ಪರಿಶೀಲಿಸಲಾಗಿದೆ · {regulation} ಅಡಿಯಲ್ಲಿ ದಾಖಲಿಸಲಾಗಿದೆ",
  recordedUnderAt:
    "ಓಟಿಪಿ (OTP) ಪರಿಶೀಲಿಸಲಾಗಿದೆ · {regulation} ಅಡಿಯಲ್ಲಿ {time} ಕ್ಕೆ ದಾಖಲಿಸಲಾಗಿದೆ",
  consentReferenceId: "ಸಮ್ಮತಿ ಉಲ್ಲೇಖ ಐಡಿ",
  proceed: "ಮುಂದುವರಿಯಿರಿ",
  loadingNotice: "ಸೂಚನೆ ಲೋಡ್ ಆಗುತ್ತಿದೆ",
  loadFailedTitle: "ಸಮ್ಮತಿ ಸೂಚನೆಯನ್ನು ಲೋಡ್ ಮಾಡಲಾಗಲಿಲ್ಲ",
  tryAgain: "ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
  close: "ಮುಚ್ಚಿ",
};

const ks: StaticStrings = {
  useEmailInstead: "ای میل استعمال کرِو",
  useMobileInstead: "موبایل استعمال کرِو",
  emailAddress: "ای میل ایڈریس",
  otpHelperEmail: "أسؠ بھیجو اَتھ ای میلس پؠٹھ اکھ ون ٹایم پاسورڈ۔",
  changeEmail: "ای میل تبدیل کرِو",
  expandDetails: "{name} تفصیلات کھولِو",
  collapseDetails: "{name} تفصیلات بند کرِو",
  selectAllFor: "{name} خٲطرٕ سٲری ڈیٹا عناصر ژارٕو",
  selectElement: "{name} ژارٕو",
  selectElementRequired: "{name} ژارٕو (ضروری)",
  required: "ضروری",
  logoAlt: "لوگو",
  selectLanguage: "زبان ژارٕو",
  selectLanguageCurrent: "زبان ژارٕو۔ موجودٕ زبان: {lang}",
  opensInNewTab: "نٔو ٹیب منٛز کھولان",
  audioStart: "آڈیو پلے بیک شروٗع کرِو",
  audioPause: "آڈیو پلے بیک روکِو",
  talkbackStart: "ٹاک بیک شروٗع کرِو",
  talkbackPause: "ٹاک بیک روکِو",
  mobileNumber: "موبایل نمبر",
  otpHelper: "أسؠ بھیجو اَتھ نمبرس پؠٹھ اکھ ون ٹایم پاسورڈ۔",
  otpSentTo: "او ٹی پی (OTP) بھیجِو",
  changeMobile: "موبایل نمبر تبدیل کرِو",
  enterNDigitOtp: "{count}-ہندسن ہُنٛد او ٹی پی (OTP) دِیُت",
  otpDigit: "او ٹی پی (OTP) ہندسہ {index}",
  resendIn: "{seconds} سیکنڈن منٛز او ٹی پی (OTP) دوبارٕ بھیجِو",
  sending: "بھیجان آسؠ…",
  resendOtp: "او ٹی پی (OTP) دوبارٕ بھیجِو",
  getOtp: "او ٹی پی (OTP) حٲصِل کرِو",
  verifying: "تصدیق کران آسؠ…",
  verifyOtp: "او ٹی پی (OTP) تصدیق کرِو",
  sendOtp: "او ٹی پی (OTP) بھیجِو",
  confirmOtp: "او ٹی پی (OTP) پۄختہ کرِو",
  verifyWithOtp: "او ٹی پی (OTP) سٟتؠ تصدیق کرِو",
  editSelections: "ژارٕمٕژ تبدیل کرِو",
  otpIncorrect:
    "تُہند درج کرمُت تصدیقی کوڈ چھ غلط۔ مہربانی کرِتھ چیک کرِتھ دوبارٕ کوشش کریو۔",
  otpExpired:
    "تُہند تصدیقی کوڈ ہنٛد میعاد چھ ختم گژھمُت۔ مہربانی کرِتھ نٔو کوڈ طلب کریو۔",
  otpNotFound: "تصدیقی کوڈ آو نہ لبنہ۔ مہربانی کرِتھ نٔو کوڈ طلب کریو۔",
  otpVerifyFailed:
    "او ٹی پی (OTP) ہیوٚک نہ تصدیق کرنہ۔ مہربانی کرِتھ دوبارٕ کوشش کریو۔",
  otpSendFailed:
    "او ٹی پی (OTP) ہیوٚک نہ بھیجنہ۔ مہربانی کرِتھ دوبارٕ کوشش کریو۔",
  consentConfirmed: "رضامندی تصدیق آیہٕ",
  recordedUnder: "او ٹی پی (OTP) تصدیق · {regulation} تحت درج",
  recordedUnderAt: "او ٹی پی (OTP) تصدیق · {regulation} تحت {time} پؠٹھ درج",
  consentReferenceId: "رضامندی ریفرنس آی ڈی",
  proceed: "اگٕ بڑھِو",
  loadingNotice: "نوٹس لوڈ گژھان آسؠ",
  loadFailedTitle: "رضامندی نوٹس لوڈ کرِتھ ہیوٚک نہٕ",
  tryAgain: "مہربانی کرِتھ دوبارٕ کوشش کرِو۔",
  close: "بند کرِو",
};

const gom: StaticStrings = {
  useEmailInstead: "ईमेल वापरात",
  useMobileInstead: "मोबायल वापरात",
  emailAddress: "ईमेल पत्तो",
  otpHelperEmail: "आमी ह्या ईमेलाचेर एक वेळचो पासवर्ड धाडटले.",
  changeEmail: "ईमेल बदलात",
  expandDetails: "{name} चो तपशील विस्तारीत करात",
  collapseDetails: "{name} चो तपशील संकुचित करात",
  selectAllFor: "{name} खातीर सगळे डेटा घटक निवडात",
  selectElement: "{name} निवडात",
  selectElementRequired: "{name} निवडात (गरजेचें)",
  required: "गरजेचें",
  logoAlt: "लोगो",
  selectLanguage: "भास निवडात",
  selectLanguageCurrent: "भास निवडात. सद्याची भास: {lang}",
  opensInNewTab: "नव्या टॅबांत उगडता",
  audioStart: "ऑडियो प्लेबॅक सुरू करात",
  audioPause: "ऑडियो प्लेबॅक थांबयात",
  talkbackStart: "टॉकबॅक सुरू करात",
  talkbackPause: "टॉकबॅक थांबयात",
  mobileNumber: "मोबायल क्रमांक",
  otpHelper: "आमी ह्या क्रमांकाचेर एक वेळचो पासवर्ड धाडटले.",
  otpSentTo: "ओटीपी (OTP) धाडलो",
  changeMobile: "मोबायल क्रमांक बदलात",
  enterNDigitOtp: "{count}-आंकडी ओटीपी (OTP) घालात",
  otpDigit: "ओटीपी (OTP) आंकडो {index}",
  resendIn: "{seconds} सेकंदांनी ओटीपी (OTP) परत धाडात",
  sending: "धाडटा…",
  resendOtp: "ओटीपी (OTP) परत धाडात",
  getOtp: "ओटीपी (OTP) मेळयात",
  verifying: "तपासता…",
  verifyOtp: "ओटीपी (OTP) तपासात",
  sendOtp: "ओटीपी (OTP) धाडात",
  confirmOtp: "ओटीपी (OTP) निश्चीत करात",
  verifyWithOtp: "ओटीपी (OTP) वरवीं तपासात",
  editSelections: "निवडी संपादित करात",
  otpIncorrect:
    "तुमी घाललो पडताळणी कोड चुकीचो आसा. उपकार करून तपासात आनी परत यत्न करात.",
  otpExpired: "तुमच्या पडताळणी कोडाची मुदत सोंपली. उपकार करून नवो कोड मागात.",
  otpNotFound: "पडताळणी कोड मेळूंक ना. उपकार करून नवो कोड मागात.",
  otpVerifyFailed: "ओटीपी (OTP) पडताळूंक जमलें ना. उपकार करून परत यत्न करात.",
  otpSendFailed: "ओटीपी (OTP) धाडूंक जमलें ना. उपकार करून परत यत्न करात.",
  consentConfirmed: "संमती निश्चीत जाली",
  recordedUnder: "ओटीपी (OTP) तपासलो · {regulation} खाला नोंद केली",
  recordedUnderAt:
    "ओटीपी (OTP) तपासलो · {regulation} खाला {time} वोरांचेर नोंद केली",
  consentReferenceId: "संमती संदर्भ आयडी",
  proceed: "फुडें वचात",
  loadingNotice: "नोटीस लोड जाता",
  loadFailedTitle: "संमती नोटीस लोड करूंक जमलें ना",
  tryAgain: "उपकार करून परत यत्न करात.",
  close: "बंद करात",
};

const mai: StaticStrings = {
  useEmailInstead: "ईमेल उपयोग करू",
  useMobileInstead: "मोबाइल उपयोग करू",
  emailAddress: "ईमेल पता",
  otpHelperEmail: "हम एहि ईमेल पर एकटा वन-टाइम पासवर्ड पठाएब.",
  changeEmail: "ईमेल बदलू",
  expandDetails: "{name} क विवरण विस्तृत करू",
  collapseDetails: "{name} क विवरण संक्षिप्त करू",
  selectAllFor: "{name} लेल सभ डेटा तत्व चुनू",
  selectElement: "{name} चुनू",
  selectElementRequired: "{name} चुनू (आवश्यक)",
  required: "आवश्यक",
  logoAlt: "लोगो",
  selectLanguage: "भाषा चुनू",
  selectLanguageCurrent: "भाषा चुनू. वर्तमान भाषा: {lang}",
  opensInNewTab: "नव टैब मे खुजैत अछि",
  audioStart: "ऑडियो प्लेबैक शुरू करू",
  audioPause: "ऑडियो प्लेबैक रोकू",
  talkbackStart: "टॉकबैक शुरू करू",
  talkbackPause: "टॉकबैक रोकू",
  mobileNumber: "मोबाइल नंबर",
  otpHelper: "हम एहि नंबर पर एकटा वन-टाइम पासवर्ड पठाएब.",
  otpSentTo: "ओटीपी (OTP) पठाओल गेल",
  changeMobile: "मोबाइल नंबर बदलू",
  enterNDigitOtp: "{count}-अंक क ओटीपी (OTP) दर्ज करू",
  otpDigit: "ओटीपी (OTP) अंक {index}",
  resendIn: "{seconds} सेकंड मे ओटीपी (OTP) पुनः पठाउ",
  sending: "पठाओल जा रहल अछि…",
  resendOtp: "ओटीपी (OTP) पुनः पठाउ",
  getOtp: "ओटीपी (OTP) प्राप्त करू",
  verifying: "सत्यापित कैल जा रहल अछि…",
  verifyOtp: "ओटीपी (OTP) सत्यापित करू",
  sendOtp: "ओटीपी (OTP) पठाउ",
  confirmOtp: "ओटीपी (OTP) क पुष्टि करू",
  verifyWithOtp: "ओटीपी (OTP) सँ सत्यापित करू",
  editSelections: "चयन संपादित करू",
  otpIncorrect:
    "अहाँक दर्ज कएल सत्यापन कोड गलत अछि. कृपया जाँचू आ फेर प्रयास करू.",
  otpExpired: "अहाँक सत्यापन कोडक अवधि समाप्त भ' गेल. कृपया नव कोड मांगू.",
  otpNotFound: "सत्यापन कोड नहि भेटल. कृपया नव कोड मांगू.",
  otpVerifyFailed: "ओटीपी (OTP) सत्यापित नहि भ' सकल. कृपया फेर प्रयास करू.",
  otpSendFailed: "ओटीपी (OTP) पठाओल नहि जा सकल. कृपया फेर प्रयास करू.",
  consentConfirmed: "सहमति क पुष्टि भेल",
  recordedUnder: "ओटीपी (OTP) सत्यापित · {regulation} क अंतर्गत दर्ज",
  recordedUnderAt:
    "ओटीपी (OTP) सत्यापित · {regulation} क अंतर्गत {time} बजे दर्ज",
  consentReferenceId: "सहमति संदर्भ आईडी",
  proceed: "आगू बढ़ू",
  loadingNotice: "नोटिस लोड भ' रहल अछि",
  loadFailedTitle: "सहमति नोटिस लोड नहि भ' सकल",
  tryAgain: "कृपया पुनः प्रयास करू.",
  close: "बंद करू",
};

const ml: StaticStrings = {
  useEmailInstead: "ഇമെയിൽ ഉപയോഗിക്കുക",
  useMobileInstead: "മൊബൈൽ ഉപയോഗിക്കുക",
  emailAddress: "ഇമെയിൽ വിലാസം",
  otpHelperEmail: "ഞങ്ങൾ ഈ ഇമെയിലിലേക്ക് ഒറ്റത്തവണ പാസ്‌വേഡ് അയയ്ക്കും.",
  changeEmail: "ഇമെയിൽ മാറ്റുക",
  expandDetails: "{name} വിശദാംശങ്ങൾ വികസിപ്പിക്കുക",
  collapseDetails: "{name} വിശദാംശങ്ങൾ ചുരുക്കുക",
  selectAllFor: "{name} എന്നതിനായി എല്ലാ ഡാറ്റ ഘടകങ്ങളും തിരഞ്ഞെടുക്കുക",
  selectElement: "{name} തിരഞ്ഞെടുക്കുക",
  selectElementRequired: "{name} തിരഞ്ഞെടുക്കുക (ആവശ്യമാണ്)",
  required: "ആവശ്യമാണ്",
  logoAlt: "ലോഗോ",
  selectLanguage: "ഭാഷ തിരഞ്ഞെടുക്കുക",
  selectLanguageCurrent: "ഭാഷ തിരഞ്ഞെടുക്കുക. നിലവിലെ ഭാഷ: {lang}",
  opensInNewTab: "പുതിയ ടാബിൽ തുറക്കുന്നു",
  audioStart: "ഓഡിയോ പ്ലേബാക്ക് ആരംഭിക്കുക",
  audioPause: "ഓഡിയോ പ്ലേബാക്ക് താൽക്കാലികമായി നിർത്തുക",
  talkbackStart: "ടോക്ക്ബാക്ക് ആരംഭിക്കുക",
  talkbackPause: "ടോക്ക്ബാക്ക് താൽക്കാലികമായി നിർത്തുക",
  mobileNumber: "മൊബൈൽ നമ്പർ",
  otpHelper: "ഞങ്ങൾ ഈ നമ്പറിലേക്ക് ഒറ്റത്തവണ പാസ്‌വേഡ് അയയ്ക്കും.",
  otpSentTo: "ഒടിപി (OTP) അയച്ചു",
  changeMobile: "മൊബൈൽ നമ്പർ മാറ്റുക",
  enterNDigitOtp: "{count}-അക്ക ഒടിപി (OTP) നൽകുക",
  otpDigit: "ഒടിപി (OTP) അക്കം {index}",
  resendIn: "{seconds} സെക്കൻഡിൽ ഒടിപി (OTP) വീണ്ടും അയയ്ക്കുക",
  sending: "അയയ്ക്കുന്നു…",
  resendOtp: "ഒടിപി (OTP) വീണ്ടും അയയ്ക്കുക",
  getOtp: "ഒടിപി (OTP) നേടുക",
  verifying: "പരിശോധിക്കുന്നു…",
  verifyOtp: "ഒടിപി (OTP) പരിശോധിക്കുക",
  sendOtp: "ഒടിപി (OTP) അയയ്ക്കുക",
  confirmOtp: "ഒടിപി (OTP) സ്ഥിരീകരിക്കുക",
  verifyWithOtp: "ഒടിപി (OTP) ഉപയോഗിച്ച് പരിശോധിക്കുക",
  editSelections: "തിരഞ്ഞെടുപ്പുകൾ എഡിറ്റ് ചെയ്യുക",
  otpIncorrect:
    "നിങ്ങൾ നൽകിയ പരിശോധനാ കോഡ് തെറ്റാണ്. ദയവായി പരിശോധിച്ച് വീണ്ടും ശ്രമിക്കുക.",
  otpExpired:
    "നിങ്ങളുടെ പരിശോധനാ കോഡിന്റെ കാലാവധി കഴിഞ്ഞു. ദയവായി പുതിയ കോഡ് അഭ്യർത്ഥിക്കുക.",
  otpNotFound:
    "പരിശോധനാ കോഡ് കണ്ടെത്തിയില്ല. ദയവായി പുതിയ കോഡ് അഭ്യർത്ഥിക്കുക.",
  otpVerifyFailed: "ഒടിപി (OTP) പരിശോധിക്കാനായില്ല. ദയവായി വീണ്ടും ശ്രമിക്കുക.",
  otpSendFailed: "ഒടിപി (OTP) അയയ്ക്കാനായില്ല. ദയവായി വീണ്ടും ശ്രമിക്കുക.",
  consentConfirmed: "സമ്മതം സ്ഥിരീകരിച്ചു",
  recordedUnder: "ഒടിപി (OTP) പരിശോധിച്ചു · {regulation} പ്രകാരം രേഖപ്പെടുത്തി",
  recordedUnderAt:
    "ഒടിപി (OTP) പരിശോധിച്ചു · {regulation} പ്രകാരം {time}-ന് രേഖപ്പെടുത്തി",
  consentReferenceId: "സമ്മത റഫറൻസ് ഐഡി",
  proceed: "തുടരുക",
  loadingNotice: "നോട്ടീസ് ലോഡ് ചെയ്യുന്നു",
  loadFailedTitle: "സമ്മത നോട്ടീസ് ലോഡ് ചെയ്യാനായില്ല",
  tryAgain: "ദയവായി വീണ്ടും ശ്രമിക്കുക.",
  close: "അടയ്ക്കുക",
};

const mniMtei: StaticStrings = {
  useEmailInstead: "ইমেইল শিজিন্নবা",
  useMobileInstead: "মোবাইল শিজিন্নবা",
  emailAddress: "ইমেইল ঠিকানা",
  otpHelperEmail: "ঐখোয়না ইমেইল অসিদা অমুক্তং শিজিন্নবা পাসৱার্দ থাগনি।",
  changeEmail: "ইমেইল হোংদোকউ",
  expandDetails: "{name} গী অকুপ্পা ৱারোল ফোংদোকউ",
  collapseDetails: "{name} গী অকুপ্পা ৱারোল হুপশিনউ",
  selectAllFor: "{name} গীদমক ডেটা পুম্নমক খনগৎলু",
  selectElement: "{name} খনগৎলু",
  selectElementRequired: "{name} খনগৎলু (দরকার ওই)",
  required: "দরকার ওই",
  logoAlt: "লোগো",
  selectLanguage: "লোল খনগৎলু",
  selectLanguageCurrent: "লোল খনগৎলু। হৌজিক্কী লোল: {lang}",
  opensInNewTab: "অনৌবা টেবত হাংই",
  audioStart: "অডিও প্লেবেক হৌদোকউ",
  audioPause: "অডিও প্লেবেক লেপশিনউ",
  talkbackStart: "টোকবেক হৌদোকউ",
  talkbackPause: "টোকবেক লেপশিনউ",
  mobileNumber: "মোবাইল নম্বর",
  otpHelper: "ঐখোয়না নম্বর অসিদা অমুক্তং শিজিন্নবা পাসৱার্দ থাগনি।",
  otpSentTo: "ওটিপি (OTP) থাখ্রে",
  changeMobile: "মোবাইল নম্বর হোংদোকউ",
  enterNDigitOtp: "{count}-মশিংগী ওটিপি (OTP) চংশিল্লু",
  otpDigit: "ওটিপি (OTP) মশিং {index}",
  resendIn: "{seconds} সেকেন্দগী মনুংদা ওটিপি (OTP) অমুক হন্না থাউ",
  sending: "থারি…",
  resendOtp: "ওটিপি (OTP) অমুক হন্না থাউ",
  getOtp: "ওটিপি (OTP) ফংউ",
  verifying: "শোয়দনা য়েংলি…",
  verifyOtp: "ওটিপি (OTP) শোয়দনা য়েংউ",
  sendOtp: "ওটিপি (OTP) থাউ",
  confirmOtp: "ওটিপি (OTP) চপ চানা শেংদোকউ",
  verifyWithOtp: "ওটিপি (OTP) না শোয়দনা য়েংউ",
  editSelections: "খনগৎলবশিং শেমদোকউ",
  otpIncorrect:
    "নহাক্না চংশিল্লবা ভেরিফিকেসন কোদ অসি অরানবনি। চানবীদুনা য়েংশিল্লগা অমুক হন্না হোৎনবীয়ু।",
  otpExpired:
    "নহাক্কী ভেরিফিকেসন কোদ অসিগী মতম লোইখ্রে। চানবীদুনা অনৌবা কোদ অমা নিজবীয়ু।",
  otpNotFound: "ভেরিফিকেসন কোদ ফংদ্রে। চানবীদুনা অনৌবা কোদ অমা নিজবীয়ু।",
  otpVerifyFailed:
    "ওটিপি (OTP) শোয়দনা য়েংবা ঙমদ্রে। চানবীদুনা অমুক হন্না হোৎনবীয়ু।",
  otpSendFailed: "ওটিপি (OTP) থাবা ঙমদ্রে। চানবীদুনা অমুক হন্না হোৎনবীয়ু।",
  consentConfirmed: "অয়াবা চপ চানা শেংদোকখ্রে",
  recordedUnder:
    "ওটিপি (OTP) শোয়দনা য়েংলে · {regulation} গী মখাদা রেকর্ড তৌখ্রে",
  recordedUnderAt:
    "ওটিপি (OTP) শোয়দনা য়েংলে · {regulation} গী মখাদা {time} দা রেকর্ড তৌখ্রে",
  consentReferenceId: "অয়াবা রেফরেন্স আইদি",
  proceed: "মখা চৎথউ",
  loadingNotice: "নোতিস লোদ তৌরি",
  loadFailedTitle: "অয়াবা নোতিস লোদ তৌবা ঙমদে",
  tryAgain: "চানবীদুনা অমুক হন্না হোৎনবীয়ু।",
  close: "লোনশিনউ",
};

const mr: StaticStrings = {
  useEmailInstead: "ईमेल वापरा",
  useMobileInstead: "मोबाइल वापरा",
  emailAddress: "ईमेल पत्ता",
  otpHelperEmail: "आम्ही या ईमेलवर एक-वेळचा पासवर्ड पाठवू.",
  changeEmail: "ईमेल बदला",
  expandDetails: "{name} चे तपशील विस्तृत करा",
  collapseDetails: "{name} चे तपशील संक्षिप्त करा",
  selectAllFor: "{name} साठी सर्व डेटा घटक निवडा",
  selectElement: "{name} निवडा",
  selectElementRequired: "{name} निवडा (आवश्यक)",
  required: "आवश्यक",
  logoAlt: "लोगो",
  selectLanguage: "भाषा निवडा",
  selectLanguageCurrent: "भाषा निवडा. सध्याची भाषा: {lang}",
  opensInNewTab: "नवीन टॅबमध्ये उघडते",
  audioStart: "ऑडिओ प्लेबॅक सुरू करा",
  audioPause: "ऑडिओ प्लेबॅक थांबवा",
  talkbackStart: "टॉकबॅक सुरू करा",
  talkbackPause: "टॉकबॅक थांबवा",
  mobileNumber: "मोबाइल नंबर",
  otpHelper: "आम्ही या नंबरवर एक-वेळचा पासवर्ड पाठवू.",
  otpSentTo: "ओटीपी (OTP) पाठवला",
  changeMobile: "मोबाइल नंबर बदला",
  enterNDigitOtp: "{count}-अंकी ओटीपी (OTP) प्रविष्ट करा",
  otpDigit: "ओटीपी (OTP) अंक {index}",
  resendIn: "{seconds} सेकंदात ओटीपी (OTP) पुन्हा पाठवा",
  sending: "पाठवत आहे…",
  resendOtp: "ओटीपी (OTP) पुन्हा पाठवा",
  getOtp: "ओटीपी (OTP) मिळवा",
  verifying: "पडताळत आहे…",
  verifyOtp: "ओटीपी (OTP) पडताळा",
  sendOtp: "ओटीपी (OTP) पाठवा",
  confirmOtp: "ओटीपी (OTP) ची पुष्टी करा",
  verifyWithOtp: "ओटीपी (OTP) ने पडताळा",
  editSelections: "निवडी संपादित करा",
  otpIncorrect:
    "तुम्ही प्रविष्ट केलेला पडताळणी कोड चुकीचा आहे. कृपया तपासा आणि पुन्हा प्रयत्न करा.",
  otpExpired: "तुमच्या पडताळणी कोडची मुदत संपली आहे. कृपया नवीन कोड मागवा.",
  otpNotFound: "पडताळणी कोड सापडला नाही. कृपया नवीन कोड मागवा.",
  otpVerifyFailed: "ओटीपी (OTP) पडताळता आला नाही. कृपया पुन्हा प्रयत्न करा.",
  otpSendFailed: "ओटीपी (OTP) पाठवता आला नाही. कृपया पुन्हा प्रयत्न करा.",
  consentConfirmed: "संमती निश्चित झाली",
  recordedUnder: "ओटीपी (OTP) पडताळला · {regulation} अंतर्गत नोंदवले",
  recordedUnderAt:
    "ओटीपी (OTP) पडताळला · {regulation} अंतर्गत {time} वाजता नोंदवले",
  consentReferenceId: "संमती संदर्भ आयडी",
  proceed: "पुढे जा",
  loadingNotice: "सूचना लोड होत आहे",
  loadFailedTitle: "संमती सूचना लोड करता आली नाही",
  tryAgain: "कृपया पुन्हा प्रयत्न करा.",
  close: "बंद करा",
};

const ne: StaticStrings = {
  useEmailInstead: "इमेल प्रयोग गर्नुहोस्",
  useMobileInstead: "मोबाइल प्रयोग गर्नुहोस्",
  emailAddress: "इमेल ठेगाना",
  otpHelperEmail: "हामी यो इमेलमा एक-पटक प्रयोग हुने पासवर्ड पठाउनेछौं।",
  changeEmail: "इमेल परिवर्तन गर्नुहोस्",
  expandDetails: "{name} को विवरण विस्तार गर्नुहोस्",
  collapseDetails: "{name} को विवरण संक्षिप्त गर्नुहोस्",
  selectAllFor: "{name} का लागि सबै डेटा तत्वहरू चयन गर्नुहोस्",
  selectElement: "{name} चयन गर्नुहोस्",
  selectElementRequired: "{name} चयन गर्नुहोस् (आवश्यक)",
  required: "आवश्यक",
  logoAlt: "लोगो",
  selectLanguage: "भाषा चयन गर्नुहोस्",
  selectLanguageCurrent: "भाषा चयन गर्नुहोस्। हालको भाषा: {lang}",
  opensInNewTab: "नयाँ ट्याबमा खुल्छ",
  audioStart: "अडियो प्लेब्याक सुरु गर्नुहोस्",
  audioPause: "अडियो प्लेब्याक रोक्नुहोस्",
  talkbackStart: "टकब्याक सुरु गर्नुहोस्",
  talkbackPause: "टकब्याक रोक्नुहोस्",
  mobileNumber: "मोबाइल नम्बर",
  otpHelper: "हामी यो नम्बरमा एक-पटक प्रयोग हुने पासवर्ड पठाउनेछौं।",
  otpSentTo: "ओटीपी (OTP) पठाइयो",
  changeMobile: "मोबाइल नम्बर परिवर्तन गर्नुहोस्",
  enterNDigitOtp: "{count}-अङ्कको ओटीपी (OTP) प्रविष्ट गर्नुहोस्",
  otpDigit: "ओटीपी (OTP) अङ्क {index}",
  resendIn: "{seconds} सेकेन्डमा ओटीपी (OTP) पुनः पठाउनुहोस्",
  sending: "पठाउँदै…",
  resendOtp: "ओटीपी (OTP) पुनः पठाउनुहोस्",
  getOtp: "ओटीपी (OTP) प्राप्त गर्नुहोस्",
  verifying: "प्रमाणित गर्दै…",
  verifyOtp: "ओटीपी (OTP) प्रमाणित गर्नुहोस्",
  sendOtp: "ओटीपी (OTP) पठाउनुहोस्",
  confirmOtp: "ओटीपी (OTP) पुष्टि गर्नुहोस्",
  verifyWithOtp: "ओटीपी (OTP) मार्फत प्रमाणित गर्नुहोस्",
  editSelections: "चयनहरू सम्पादन गर्नुहोस्",
  otpIncorrect:
    "तपाईंले प्रविष्ट गर्नुभएको प्रमाणीकरण कोड गलत छ. कृपया जाँच गरी पुनः प्रयास गर्नुहोस्.",
  otpExpired:
    "तपाईंको प्रमाणीकरण कोडको म्याद सकिएको छ. कृपया नयाँ कोड अनुरोध गर्नुहोस्.",
  otpNotFound: "प्रमाणीकरण कोड फेला परेन. कृपया नयाँ कोड अनुरोध गर्नुहोस्.",
  otpVerifyFailed:
    "ओटीपी (OTP) प्रमाणित गर्न सकिएन. कृपया पुनः प्रयास गर्नुहोस्.",
  otpSendFailed: "ओटीपी (OTP) पठाउन सकिएन. कृपया पुनः प्रयास गर्नुहोस्.",
  consentConfirmed: "सहमति पुष्टि भयो",
  recordedUnder: "ओटीपी (OTP) प्रमाणित · {regulation} अन्तर्गत अभिलेख गरियो",
  recordedUnderAt:
    "ओटीपी (OTP) प्रमाणित · {regulation} अन्तर्गत {time} मा अभिलेख गरियो",
  consentReferenceId: "सहमति सन्दर्भ आईडी",
  proceed: "अगाडि बढ्नुहोस्",
  loadingNotice: "सूचना लोड हुँदै",
  loadFailedTitle: "सहमति सूचना लोड गर्न सकिएन",
  tryAgain: "कृपया पुनः प्रयास गर्नुहोस्।",
  close: "बन्द गर्नुहोस्",
};

const or: StaticStrings = {
  useEmailInstead: "ଇମେଲ୍ ବ୍ୟବହାର କରନ୍ତୁ",
  useMobileInstead: "ମୋବାଇଲ୍ ବ୍ୟବହାର କରନ୍ତୁ",
  emailAddress: "ଇମେଲ୍ ଠିକଣା",
  otpHelperEmail: "ଆମେ ଏହି ଇମେଲକୁ ଗୋଟିଏ-ଥର ବ୍ୟବହାର ପାସୱର୍ଡ ପଠାଇବୁ।",
  changeEmail: "ଇମେଲ୍ ବଦଳାନ୍ତୁ",
  expandDetails: "{name} ର ବିବରଣୀ ବିସ୍ତାର କରନ୍ତୁ",
  collapseDetails: "{name} ର ବିବରଣୀ ସଙ୍କୁଚିତ କରନ୍ତୁ",
  selectAllFor: "{name} ପାଇଁ ସମସ୍ତ ଡାଟା ଉପାଦାନ ବାଛନ୍ତୁ",
  selectElement: "{name} ବାଛନ୍ତୁ",
  selectElementRequired: "{name} ବାଛନ୍ତୁ (ଆବଶ୍ୟକ)",
  required: "ଆବଶ୍ୟକ",
  logoAlt: "ଲୋଗୋ",
  selectLanguage: "ଭାଷା ବାଛନ୍ତୁ",
  selectLanguageCurrent: "ଭାଷା ବାଛନ୍ତୁ। ବର୍ତ୍ତମାନର ଭାଷା: {lang}",
  opensInNewTab: "ନୂଆ ଟ୍ୟାବରେ ଖୋଲେ",
  audioStart: "ଅଡିଓ ପ୍ଲେବ୍ୟାକ୍ ଆରମ୍ଭ କରନ୍ତୁ",
  audioPause: "ଅଡିଓ ପ୍ଲେବ୍ୟାକ୍ ବିରତ କରନ୍ତୁ",
  talkbackStart: "ଟକ୍‌ବ୍ୟାକ୍ ଆରମ୍ଭ କରନ୍ତୁ",
  talkbackPause: "ଟକ୍‌ବ୍ୟାକ୍ ବିରତ କରନ୍ତୁ",
  mobileNumber: "ମୋବାଇଲ୍ ନମ୍ବର",
  otpHelper: "ଆମେ ଏହି ନମ୍ବରକୁ ଗୋଟିଏ-ଥର ବ୍ୟବହାର ପାସୱର୍ଡ ପଠାଇବୁ।",
  otpSentTo: "ଓଟିପି (OTP) ପଠାଗଲା",
  changeMobile: "ମୋବାଇଲ୍ ନମ୍ବର ବଦଳାନ୍ତୁ",
  enterNDigitOtp: "{count}-ଅଙ୍କ ବିଶିଷ୍ଟ ଓଟିପି (OTP) ଭରନ୍ତୁ",
  otpDigit: "ଓଟିପି (OTP) ଅଙ୍କ {index}",
  resendIn: "{seconds} ସେକେଣ୍ଡରେ ଓଟିପି (OTP) ପୁନଃ ପଠାନ୍ତୁ",
  sending: "ପଠାଯାଉଛି…",
  resendOtp: "ଓଟିପି (OTP) ପୁନଃ ପଠାନ୍ତୁ",
  getOtp: "ଓଟିପି (OTP) ପାଆନ୍ତୁ",
  verifying: "ଯାଞ୍ଚ କରାଯାଉଛି…",
  verifyOtp: "ଓଟିପି (OTP) ଯାଞ୍ଚ କରନ୍ତୁ",
  sendOtp: "ଓଟିପି (OTP) ପଠାନ୍ତୁ",
  confirmOtp: "ଓଟିପି (OTP) ନିଶ୍ଚିତ କରନ୍ତୁ",
  verifyWithOtp: "ଓଟିପି (OTP) ମାଧ୍ୟମରେ ଯାଞ୍ଚ କରନ୍ତୁ",
  editSelections: "ଚୟନଗୁଡ଼ିକ ସମ୍ପାଦନ କରନ୍ତୁ",
  otpIncorrect:
    "ଆପଣ ଭରିଥିବା ଯାଞ୍ଚ କୋଡ୍ ଭୁଲ ଅଛି। ଦୟାକରି ଯାଞ୍ଚ କରି ପୁଣି ଚେଷ୍ଟା କରନ୍ତୁ।",
  otpExpired: "ଆପଣଙ୍କ ଯାଞ୍ଚ କୋଡ୍‌ର ମିଆଦ ସରିଯାଇଛି। ଦୟାକରି ନୂଆ କୋଡ୍ ମାଗନ୍ତୁ।",
  otpNotFound: "ଯାଞ୍ଚ କୋଡ୍ ମିଳିଲା ନାହିଁ। ଦୟାକରି ନୂଆ କୋଡ୍ ମାଗନ୍ତୁ।",
  otpVerifyFailed:
    "ଓଟିପି (OTP) ଯାଞ୍ଚ କରାଯାଇପାରିଲା ନାହିଁ। ଦୟାକରି ପୁଣି ଚେଷ୍ଟା କରନ୍ତୁ।",
  otpSendFailed: "ଓଟିପି (OTP) ପଠାଯାଇପାରିଲା ନାହିଁ। ଦୟାକରି ପୁଣି ଚେଷ୍ଟା କରନ୍ତୁ।",
  consentConfirmed: "ସମ୍ମତି ନିଶ୍ଚିତ ହେଲା",
  recordedUnder: "ଓଟିପି (OTP) ଯାଞ୍ଚ ହେଲା · {regulation} ଅଧୀନରେ ରେକର୍ଡ କରାଗଲା",
  recordedUnderAt:
    "ଓଟିପି (OTP) ଯାଞ୍ଚ ହେଲା · {regulation} ଅଧୀନରେ {time}ରେ ରେକର୍ଡ କରାଗଲା",
  consentReferenceId: "ସମ୍ମତି ରେଫରେନ୍ସ ଆଇଡି",
  proceed: "ଆଗକୁ ବଢ଼ନ୍ତୁ",
  loadingNotice: "ବିଜ୍ଞପ୍ତି ଲୋଡ୍ ହେଉଛି",
  loadFailedTitle: "ସମ୍ମତି ବିଜ୍ଞପ୍ତି ଲୋଡ୍ କରାଯାଇପାରିଲା ନାହିଁ",
  tryAgain: "ଦୟାକରି ପୁନଃ ଚେଷ୍ଟା କରନ୍ତୁ।",
  close: "ବନ୍ଦ କରନ୍ତୁ",
};

const pa: StaticStrings = {
  useEmailInstead: "ਈਮੇਲ ਵਰਤੋ",
  useMobileInstead: "ਮੋਬਾਈਲ ਵਰਤੋ",
  emailAddress: "ਈਮੇਲ ਪਤਾ",
  otpHelperEmail: "ਅਸੀਂ ਇਸ ਈਮੇਲ 'ਤੇ ਇੱਕ ਵਾਰੀ ਵਰਤੋਂ ਵਾਲਾ ਪਾਸਵਰਡ ਭੇਜਾਂਗੇ।",
  changeEmail: "ਈਮੇਲ ਬਦਲੋ",
  expandDetails: "{name} ਦੇ ਵੇਰਵੇ ਫੈਲਾਓ",
  collapseDetails: "{name} ਦੇ ਵੇਰਵੇ ਸਮੇਟੋ",
  selectAllFor: "{name} ਲਈ ਸਾਰੇ ਡਾਟਾ ਤੱਤ ਚੁਣੋ",
  selectElement: "{name} ਚੁਣੋ",
  selectElementRequired: "{name} ਚੁਣੋ (ਲੋੜੀਂਦਾ)",
  required: "ਲੋੜੀਂਦਾ",
  logoAlt: "ਲੋਗੋ",
  selectLanguage: "ਭਾਸ਼ਾ ਚੁਣੋ",
  selectLanguageCurrent: "ਭਾਸ਼ਾ ਚੁਣੋ। ਮੌਜੂਦਾ ਭਾਸ਼ਾ: {lang}",
  opensInNewTab: "ਨਵੀਂ ਟੈਬ ਵਿੱਚ ਖੁੱਲ੍ਹਦਾ ਹੈ",
  audioStart: "ਆਡੀਓ ਪਲੇਬੈਕ ਸ਼ੁਰੂ ਕਰੋ",
  audioPause: "ਆਡੀਓ ਪਲੇਬੈਕ ਰੋਕੋ",
  talkbackStart: "ਟਾਕਬੈਕ ਸ਼ੁਰੂ ਕਰੋ",
  talkbackPause: "ਟਾਕਬੈਕ ਰੋਕੋ",
  mobileNumber: "ਮੋਬਾਈਲ ਨੰਬਰ",
  otpHelper: "ਅਸੀਂ ਇਸ ਨੰਬਰ 'ਤੇ ਇੱਕ ਵਾਰੀ ਵਰਤੋਂ ਵਾਲਾ ਪਾਸਵਰਡ ਭੇਜਾਂਗੇ।",
  otpSentTo: "ਓਟੀਪੀ (OTP) ਭੇਜਿਆ ਗਿਆ",
  changeMobile: "ਮੋਬਾਈਲ ਨੰਬਰ ਬਦਲੋ",
  enterNDigitOtp: "{count}-ਅੰਕਾਂ ਵਾਲਾ ਓਟੀਪੀ (OTP) ਦਰਜ ਕਰੋ",
  otpDigit: "ਓਟੀਪੀ (OTP) ਅੰਕ {index}",
  resendIn: "{seconds} ਸਕਿੰਟਾਂ ਵਿੱਚ ਓਟੀਪੀ (OTP) ਮੁੜ ਭੇਜੋ",
  sending: "ਭੇਜਿਆ ਜਾ ਰਿਹਾ ਹੈ…",
  resendOtp: "ਓਟੀਪੀ (OTP) ਮੁੜ ਭੇਜੋ",
  getOtp: "ਓਟੀਪੀ (OTP) ਪ੍ਰਾਪਤ ਕਰੋ",
  verifying: "ਪੁਸ਼ਟੀ ਕੀਤੀ ਜਾ ਰਹੀ ਹੈ…",
  verifyOtp: "ਓਟੀਪੀ (OTP) ਦੀ ਪੁਸ਼ਟੀ ਕਰੋ",
  sendOtp: "ਓਟੀਪੀ (OTP) ਭੇਜੋ",
  confirmOtp: "ਓਟੀਪੀ (OTP) ਦੀ ਤਸਦੀਕ ਕਰੋ",
  verifyWithOtp: "ਓਟੀਪੀ (OTP) ਨਾਲ ਤਸਦੀਕ ਕਰੋ",
  editSelections: "ਚੋਣਾਂ ਸੋਧੋ",
  otpIncorrect:
    "ਤੁਹਾਡੇ ਵੱਲੋਂ ਦਰਜ ਕੀਤਾ ਤਸਦੀਕ ਕੋਡ ਗਲਤ ਹੈ। ਕਿਰਪਾ ਕਰਕੇ ਜਾਂਚ ਕਰੋ ਅਤੇ ਮੁੜ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
  otpExpired:
    "ਤੁਹਾਡੇ ਤਸਦੀਕ ਕੋਡ ਦੀ ਮਿਆਦ ਖਤਮ ਹੋ ਗਈ ਹੈ। ਕਿਰਪਾ ਕਰਕੇ ਨਵਾਂ ਕੋਡ ਮੰਗੋ।",
  otpNotFound: "ਤਸਦੀਕ ਕੋਡ ਨਹੀਂ ਮਿਲਿਆ। ਕਿਰਪਾ ਕਰਕੇ ਨਵਾਂ ਕੋਡ ਮੰਗੋ।",
  otpVerifyFailed:
    "ਓਟੀਪੀ (OTP) ਦੀ ਤਸਦੀਕ ਨਹੀਂ ਹੋ ਸਕੀ। ਕਿਰਪਾ ਕਰਕੇ ਮੁੜ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
  otpSendFailed: "ਓਟੀਪੀ (OTP) ਨਹੀਂ ਭੇਜਿਆ ਜਾ ਸਕਿਆ। ਕਿਰਪਾ ਕਰਕੇ ਮੁੜ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
  consentConfirmed: "ਸਹਿਮਤੀ ਦੀ ਪੁਸ਼ਟੀ ਹੋਈ",
  recordedUnder: "ਓਟੀਪੀ (OTP) ਦੀ ਪੁਸ਼ਟੀ · {regulation} ਅਧੀਨ ਦਰਜ ਕੀਤਾ ਗਿਆ",
  recordedUnderAt:
    "ਓਟੀਪੀ (OTP) ਦੀ ਪੁਸ਼ਟੀ · {regulation} ਅਧੀਨ {time} ਵਜੇ ਦਰਜ ਕੀਤਾ ਗਿਆ",
  consentReferenceId: "ਸਹਿਮਤੀ ਰੈਫਰੈਂਸ ਆਈਡੀ",
  proceed: "ਅੱਗੇ ਵਧੋ",
  loadingNotice: "ਨੋਟਿਸ ਲੋਡ ਹੋ ਰਿਹਾ ਹੈ",
  loadFailedTitle: "ਸਹਿਮਤੀ ਨੋਟਿਸ ਲੋਡ ਨਹੀਂ ਹੋ ਸਕਿਆ",
  tryAgain: "ਕਿਰਪਾ ਕਰਕੇ ਮੁੜ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
  close: "ਬੰਦ ਕਰੋ",
};

const sa: StaticStrings = {
  useEmailInstead: "ईमेल् उपयुज्यताम्",
  useMobileInstead: "चलदूरभाषः उपयुज्यताम्",
  emailAddress: "ईमेल्-पता",
  otpHelperEmail: "वयम् अस्मिन् ईमेल् एकवारप्रयोग-कूटशब्दं प्रेषयिष्यामः।",
  changeEmail: "ईमेल् परिवर्तयतु",
  expandDetails: "{name} इत्यस्य विवरणं विस्तारयतु",
  collapseDetails: "{name} इत्यस्य विवरणं संक्षिपतु",
  selectAllFor: "{name} कृते सर्वाणि दत्तांश-तत्त्वानि चिनोतु",
  selectElement: "{name} चिनोतु",
  selectElementRequired: "{name} चिनोतु (आवश्यकम्)",
  required: "आवश्यकम्",
  logoAlt: "प्रतीकचिह्नम्",
  selectLanguage: "भाषां चिनोतु",
  selectLanguageCurrent: "भाषां चिनोतु। वर्तमाना भाषा: {lang}",
  opensInNewTab: "नूतनपटले उद्घाटयति",
  audioStart: "श्रव्यप्रचारणम् आरभतु",
  audioPause: "श्रव्यप्रचारणं विरमयतु",
  talkbackStart: "टॉक्-बैक् आरभतु",
  talkbackPause: "टॉक्-बैक् विरमयतु",
  mobileNumber: "चलदूरभाष-सङ्ख्या",
  otpHelper: "वयम् अस्मिन् सङ्ख्यायां एकवारप्रयोग-कूटशब्दं प्रेषयिष्यामः।",
  otpSentTo: "ओटीपी (OTP) प्रेषितम्",
  changeMobile: "चलदूरभाष-सङ्ख्यां परिवर्तयतु",
  enterNDigitOtp: "{count}-अङ्कीयं ओटीपी (OTP) प्रविशतु",
  otpDigit: "ओटीपी (OTP) अङ्कः {index}",
  resendIn: "{seconds} सेकेण्ड्-काले ओटीपी (OTP) पुनः प्रेषयतु",
  sending: "प्रेष्यते…",
  resendOtp: "ओटीपी (OTP) पुनः प्रेषयतु",
  getOtp: "ओटीपी (OTP) प्राप्नोतु",
  verifying: "सत्यापयति…",
  verifyOtp: "ओटीपी (OTP) सत्यापयतु",
  sendOtp: "ओटीपी (OTP) प्रेषयतु",
  confirmOtp: "ओटीपी (OTP) सुनिश्चिनोतु",
  verifyWithOtp: "ओटीपी (OTP) द्वारा सत्यापयतु",
  editSelections: "चयनानि सम्पादयतु",
  otpIncorrect:
    "भवता प्रविष्टः सत्यापनसङ्केतः अशुद्धः अस्ति. कृपया परीक्ष्य पुनः प्रयतताम्.",
  otpExpired:
    "भवतः सत्यापनसङ्केतस्य अवधिः समाप्तः. कृपया नूतनं सङ्केतं प्रार्थयताम्.",
  otpNotFound: "सत्यापनसङ्केतः न प्राप्तः. कृपया नूतनं सङ्केतं प्रार्थयताम्.",
  otpVerifyFailed: "ओटीपी (OTP) सत्यापयितुं न शक्तम्. कृपया पुनः प्रयतताम्.",
  otpSendFailed: "ओटीपी (OTP) प्रेषयितुं न शक्तम्. कृपया पुनः प्रयतताम्.",
  consentConfirmed: "सम्मतिः सुनिश्चिता",
  recordedUnder: "ओटीपी (OTP) सत्यापितम् · {regulation} अन्तर्गतं लिखितम्",
  recordedUnderAt:
    "ओटीपी (OTP) सत्यापितम् · {regulation} अन्तर्गतं {time} समये लिखितम्",
  consentReferenceId: "सम्मति-सन्दर्भ-सङ्केतः",
  proceed: "अग्रे गच्छतु",
  loadingNotice: "सूचना आरोप्यते",
  loadFailedTitle: "सम्मति-सूचना आरोपयितुं न शक्यते",
  tryAgain: "कृपया पुनः प्रयत्नं करोतु।",
  close: "पिदधातु",
};

const sat: StaticStrings = {
  useEmailInstead: "ᱤᱢᱮᱞ ᱵᱮᱵᱷᱟᱨ ᱢᱮ",
  useMobileInstead: "ᱢᱳᱵᱟᱭᱤᱞ ᱵᱮᱵᱷᱟᱨ ᱢᱮ",
  emailAddress: "ᱤᱢᱮᱞ ᱴᱷᱤᱠᱟᱱᱟ",
  otpHelperEmail: "ᱟᱞᱮ ᱱᱚᱣᱟ ᱤᱢᱮᱞ ᱨᱮ ᱢᱤᱫ ᱫᱷᱟᱣ ᱵᱮᱵᱷᱟᱨ ᱯᱟᱥᱣᱟᱰ ᱵᱷᱮᱡᱟᱣᱟ।",
  changeEmail: "ᱤᱢᱮᱞ ᱵᱚᱫᱚᱞ ᱢᱮ",
  expandDetails: "{name} ᱨᱮᱭᱟᱜ ᱵᱤᱵᱨᱚᱬ ᱯᱟᱥᱱᱟᱣ ᱢᱮ",
  collapseDetails: "{name} ᱨᱮᱭᱟᱜ ᱵᱤᱵᱨᱚᱬ ᱦᱩᱰᱤᱧ ᱢᱮ",
  selectAllFor: "{name} ᱞᱟᱹᱜᱤᱫ ᱡᱷᱚᱛᱚ ᱰᱟᱴᱟ ᱵᱟᱵᱚᱫ ᱵᱟᱪᱷᱟᱣ ᱢᱮ",
  selectElement: "{name} ᱵᱟᱪᱷᱟᱣ ᱢᱮ",
  selectElementRequired: "{name} ᱵᱟᱪᱷᱟᱣ ᱢᱮ (ᱫᱟᱨᱠᱟᱨ)",
  required: "ᱫᱟᱨᱠᱟᱨ",
  logoAlt: "ᱞᱚᱜᱚ",
  selectLanguage: "ᱯᱟᱹᱨᱥᱤ ᱵᱟᱪᱷᱟᱣ ᱢᱮ",
  selectLanguageCurrent: "ᱯᱟᱹᱨᱥᱤ ᱵᱟᱪᱷᱟᱣ ᱢᱮ। ᱱᱤᱛᱚᱜᱟᱜ ᱯᱟᱹᱨᱥᱤ: {lang}",
  opensInNewTab: "ᱱᱟᱣᱟ ᱴᱮᱵ ᱨᱮ ᱡᱷᱤᱡ ᱟᱠᱟᱱᱟ",
  audioStart: "ᱚᱰᱤᱭᱚ ᱯᱞᱮᱵᱮᱠ ᱮᱱᱮᱫ ᱢᱮ",
  audioPause: "ᱚᱰᱤᱭᱚ ᱯᱞᱮᱵᱮᱠ ᱛᱷᱟᱢᱟᱣ ᱢᱮ",
  talkbackStart: "ᱴᱚᱠᱵᱮᱠ ᱮᱱᱮᱫ ᱢᱮ",
  talkbackPause: "ᱴᱚᱠᱵᱮᱠ ᱛᱷᱟᱢᱟᱣ ᱢᱮ",
  mobileNumber: "ᱢᱳᱵᱟᱭᱤᱞ ᱱᱚᱢᱵᱚᱨ",
  otpHelper: "ᱟᱞᱮ ᱱᱚᱣᱟ ᱱᱚᱢᱵᱚᱨ ᱨᱮ ᱢᱤᱫ ᱫᱷᱟᱣ ᱵᱮᱵᱷᱟᱨ ᱯᱟᱥᱣᱟᱰ ᱵᱷᱮᱡᱟᱣᱟ।",
  otpSentTo: "ᱚᱴᱤᱯᱤ (OTP) ᱵᱷᱮᱡᱟᱣ ᱮᱱᱟ",
  changeMobile: "ᱢᱳᱵᱟᱭᱤᱞ ᱱᱚᱢᱵᱚᱨ ᱵᱚᱫᱚᱞ ᱢᱮ",
  enterNDigitOtp: "{count}-ᱴᱷᱮᱱ ᱟᱝᱠ ᱨᱮᱱᱟᱜ ᱚᱴᱤᱯᱤ (OTP) ᱟᱫᱮᱨ ᱢᱮ",
  otpDigit: "ᱚᱴᱤᱯᱤ (OTP) ᱟᱝᱠ {index}",
  resendIn: "{seconds} ᱥᱮᱠᱮᱱᱰ ᱨᱮ ᱚᱴᱤᱯᱤ (OTP) ᱫᱳᱦᱲᱟ ᱵᱷᱮᱡᱟ ᱢᱮ",
  sending: "ᱵᱷᱮᱡᱟᱣ ᱠᱟᱱᱟ…",
  resendOtp: "ᱚᱴᱤᱯᱤ (OTP) ᱫᱳᱦᱲᱟ ᱵᱷᱮᱡᱟ ᱢᱮ",
  getOtp: "ᱚᱴᱤᱯᱤ (OTP) ᱧᱟᱢ ᱢᱮ",
  verifying: "ᱯᱟᱨᱠᱷᱟ ᱠᱟᱱᱟ…",
  verifyOtp: "ᱚᱴᱤᱯᱤ (OTP) ᱯᱟᱨᱠᱷᱟ ᱢᱮ",
  sendOtp: "ᱚᱴᱤᱯᱤ (OTP) ᱵᱷᱮᱡᱟ ᱢᱮ",
  confirmOtp: "ᱚᱴᱤᱯᱤ (OTP) ᱯᱚᱠᱠᱟ ᱢᱮ",
  verifyWithOtp: "ᱚᱴᱤᱯᱤ (OTP) ᱛᱮ ᱯᱟᱨᱠᱷᱟ ᱢᱮ",
  editSelections: "ᱵᱟᱪᱷᱟᱣ ᱥᱟᱯᱲᱟᱣ ᱢᱮ",
  otpIncorrect:
    "ᱟᱢ ᱟᱫᱮᱨ ᱟᱠᱟᱱ ᱠᱳᱰ ᱵᱷᱩᱞ ᱠᱟᱱᱟ। ᱫᱟᱭᱟ ᱠᱟᱛᱮ ᱧᱮᱞ ᱠᱟᱛᱮ ᱫᱳᱦᱲᱟ ᱠᱩᱨᱩᱢᱩᱴᱩ ᱢᱮ।",
  otpExpired: "ᱟᱢᱟᱜ ᱠᱳᱰ ᱨᱮᱱᱟᱜ ᱚᱠᱛᱚ ᱢᱩᱪᱟᱫ ᱮᱱᱟ। ᱫᱟᱭᱟ ᱠᱟᱛᱮ ᱱᱟᱣᱟ ᱠᱳᱰ ᱢᱟᱸᱜ ᱢᱮ।",
  otpNotFound: "ᱠᱳᱰ ᱵᱟᱝ ᱧᱟᱢ ᱞᱮᱱᱟ। ᱫᱟᱭᱟ ᱠᱟᱛᱮ ᱱᱟᱣᱟ ᱠᱳᱰ ᱢᱟᱸᱜ ᱢᱮ।",
  otpVerifyFailed:
    "ᱚᱴᱤᱯᱤ (OTP) ᱵᱟᱝ ᱯᱟᱨᱠᱷᱟ ᱦᱩᱭ ᱞᱮᱱᱟ। ᱫᱟᱭᱟ ᱠᱟᱛᱮ ᱫᱳᱦᱲᱟ ᱠᱩᱨᱩᱢᱩᱴᱩ ᱢᱮ।",
  otpSendFailed: "ᱚᱴᱤᱯᱤ (OTP) ᱵᱟᱝ ᱵᱷᱮᱡᱟ ᱦᱩᱭ ᱞᱮᱱᱟ। ᱫᱟᱭᱟ ᱠᱟᱛᱮ ᱫᱳᱦᱲᱟ ᱠᱩᱨᱩᱢᱩᱴᱩ ᱢᱮ।",
  consentConfirmed: "ᱨᱟᱹᱡᱤ ᱯᱚᱠᱠᱟ ᱦᱩᱭ ᱮᱱᱟ",
  recordedUnder:
    "ᱚᱴᱤᱯᱤ (OTP) ᱯᱟᱨᱠᱷᱟ ᱦᱩᱭ ᱮᱱᱟ · {regulation} ᱞᱟᱛᱟᱨ ᱨᱮ ᱱᱚᱛ ᱦᱩᱭ ᱮᱱᱟ",
  recordedUnderAt:
    "ᱚᱴᱤᱯᱤ (OTP) ᱯᱟᱨᱠᱷᱟ ᱦᱩᱭ ᱮᱱᱟ · {regulation} ᱞᱟᱛᱟᱨ ᱨᱮ {time} ᱨᱮ ᱱᱚᱛ ᱦᱩᱭ ᱮᱱᱟ",
  consentReferenceId: "ᱨᱟᱹᱡᱤ ᱨᱮᱯᱷᱨᱮᱱᱥ ᱟᱭᱰᱤ",
  proceed: "ᱟᱭᱢᱟ ᱪᱟᱞᱟᱜ ᱢᱮ",
  loadingNotice: "ᱱᱳᱴᱤᱥ ᱞᱳᱰ ᱦᱩᱭ ᱠᱟᱱᱟ",
  loadFailedTitle: "ᱨᱟᱹᱡᱤ ᱱᱳᱴᱤᱥ ᱞᱳᱰ ᱵᱟᱝ ᱦᱩᱭ ᱞᱮᱱᱟ",
  tryAgain: "ᱫᱟᱭᱟ ᱠᱟᱛᱮ ᱫᱳᱦᱲᱟ ᱠᱩᱨᱩᱢᱩᱴᱩ ᱢᱮ।",
  close: "ᱵᱚᱸᱫᱚ ᱢᱮ",
};

const sd: StaticStrings = {
  useEmailInstead: "اي ميل استعمال ڪريو",
  useMobileInstead: "موبائيل استعمال ڪريو",
  emailAddress: "اي ميل پتو",
  otpHelperEmail: "اسان هن اي ميل تي هڪ ڀيرو استعمال ٿيندڙ پاسورڊ موڪلينداسين.",
  changeEmail: "اي ميل تبديل ڪريو",
  expandDetails: "{name} جا تفصيل وڌايو",
  collapseDetails: "{name} جا تفصيل سُکيڙيو",
  selectAllFor: "{name} لاءِ سڀ ڊيٽا عنصر چونڊيو",
  selectElement: "{name} چونڊيو",
  selectElementRequired: "{name} چونڊيو (ضروري)",
  required: "ضروري",
  logoAlt: "لوگو",
  selectLanguage: "ٻولي چونڊيو",
  selectLanguageCurrent: "ٻولي چونڊيو. موجودہ ٻولي: {lang}",
  opensInNewTab: "نئين ٽيب ۾ کُلي ٿو",
  audioStart: "آڊيو پلے بيڪ شروع ڪريو",
  audioPause: "آڊيو پلے بيڪ روڪيو",
  talkbackStart: "ٽاڪ بيڪ شروع ڪريو",
  talkbackPause: "ٽاڪ بيڪ روڪيو",
  mobileNumber: "موبائيل نمبر",
  otpHelper: "اسان هن نمبر تي هڪ ڀيرو استعمال ٿيندڙ پاسورڊ موڪلينداسين.",
  otpSentTo: "او ٽي پي (OTP) موڪليو ويو",
  changeMobile: "موبائيل نمبر تبديل ڪريو",
  enterNDigitOtp: "{count}-عددن وارو او ٽي پي (OTP) داخل ڪريو",
  otpDigit: "او ٽي پي (OTP) عدد {index}",
  resendIn: "{seconds} سيڪنڊن ۾ او ٽي پي (OTP) ٻيهر موڪليو",
  sending: "موڪليو پيو وڃي…",
  resendOtp: "او ٽي پي (OTP) ٻيهر موڪليو",
  getOtp: "او ٽي پي (OTP) حاصل ڪريو",
  verifying: "تصديق ٿي رهي آهي…",
  verifyOtp: "او ٽي پي (OTP) جي تصديق ڪريو",
  sendOtp: "او ٽي پي (OTP) موڪليو",
  confirmOtp: "او ٽي پي (OTP) جي تصديق ڪريو",
  verifyWithOtp: "او ٽي پي (OTP) سان تصديق ڪريو",
  editSelections: "چونڊون تبديل ڪريو",
  otpIncorrect:
    "توهان داخل ڪيل تصديق ڪوڊ غلط آهي. مهرباني ڪري جانچيو ۽ ٻيهر ڪوشش ڪريو.",
  otpExpired:
    "توهان جي تصديق ڪوڊ جي مدت ختم ٿي وئي آهي. مهرباني ڪري نئون ڪوڊ گهرو.",
  otpNotFound: "تصديق ڪوڊ نه مليو. مهرباني ڪري نئون ڪوڊ گهرو.",
  otpVerifyFailed:
    "او ٽي پي (OTP) جي تصديق نه ٿي سگهي. مهرباني ڪري ٻيهر ڪوشش ڪريو.",
  otpSendFailed: "او ٽي پي (OTP) موڪلي نه سگهيو. مهرباني ڪري ٻيهر ڪوشش ڪريو.",
  consentConfirmed: "رضامندي جي تصديق ٿي",
  recordedUnder: "او ٽي پي (OTP) تصديق ٿيل · {regulation} تحت رڪارڊ ٿيل",
  recordedUnderAt:
    "او ٽي پي (OTP) تصديق ٿيل · {regulation} تحت {time} تي رڪارڊ ٿيل",
  consentReferenceId: "رضامندي ريفرنس آءِ ڊي",
  proceed: "اڳتي وڌو",
  loadingNotice: "نوٽيس لوڊ ٿي رهيو آهي",
  loadFailedTitle: "رضامندي نوٽيس لوڊ نه ٿي سگھيو",
  tryAgain: "مهرباني ڪري ٻيهر ڪوشش ڪريو.",
  close: "بند ڪريو",
};

const ta: StaticStrings = {
  useEmailInstead: "மின்னஞ்சல் பயன்படுத்து",
  useMobileInstead: "மொபைல் பயன்படுத்து",
  emailAddress: "மின்னஞ்சல் முகவரி",
  otpHelperEmail: "இந்த மின்னஞ்சலுக்கு ஒரு முறை பயன்படுத்தும் கடவுச்சொல்லை அனுப்புவோம்.",
  changeEmail: "மின்னஞ்சலை மாற்று",
  expandDetails: "{name} விவரங்களை விரிவாக்கு",
  collapseDetails: "{name} விவரங்களை சுருக்கு",
  selectAllFor: "{name} க்கான அனைத்து தரவு கூறுகளையும் தேர்ந்தெடு",
  selectElement: "{name} தேர்ந்தெடு",
  selectElementRequired: "{name} தேர்ந்தெடு (தேவை)",
  required: "தேவை",
  logoAlt: "லோகோ",
  selectLanguage: "மொழியைத் தேர்ந்தெடு",
  selectLanguageCurrent: "மொழியைத் தேர்ந்தெடு. தற்போதைய மொழி: {lang}",
  opensInNewTab: "புதிய தாவலில் திறக்கிறது",
  audioStart: "ஆடியோ பிளேபேக்கைத் தொடங்கு",
  audioPause: "ஆடியோ பிளேபேக்கை இடைநிறுத்து",
  talkbackStart: "டாக்பேக்கைத் தொடங்கு",
  talkbackPause: "டாக்பேக்கை இடைநிறுத்து",
  mobileNumber: "மொபைல் எண்",
  otpHelper: "இந்த எண்ணுக்கு ஒரு முறை பயன்படுத்தும் கடவுச்சொல்லை அனுப்புவோம்.",
  otpSentTo: "ஓடிபி (OTP) அனுப்பப்பட்டது",
  changeMobile: "மொபைல் எண்ணை மாற்று",
  enterNDigitOtp: "{count}-இலக்க ஓடிபி (OTP) ஐ உள்ளிடவும்",
  otpDigit: "ஓடிபி (OTP) இலக்கம் {index}",
  resendIn: "{seconds} வினாடிகளில் ஓடிபி (OTP) ஐ மீண்டும் அனுப்பு",
  sending: "அனுப்புகிறது…",
  resendOtp: "ஓடிபி (OTP) ஐ மீண்டும் அனுப்பு",
  getOtp: "ஓடிபி (OTP) பெறு",
  verifying: "சரிபார்க்கிறது…",
  verifyOtp: "ஓடிபி (OTP) ஐ சரிபார்",
  sendOtp: "ஓடிபி (OTP) ஐ அனுப்பு",
  confirmOtp: "ஓடிபி (OTP) ஐ உறுதிப்படுத்து",
  verifyWithOtp: "ஓடிபி (OTP) மூலம் சரிபார்",
  editSelections: "தேர்வுகளைத் திருத்து",
  otpIncorrect:
    "நீங்கள் உள்ளிட்ட சரிபார்ப்புக் குறியீடு தவறானது. சரிபார்த்து மீண்டும் முயற்சிக்கவும்.",
  otpExpired:
    "உங்கள் சரிபார்ப்புக் குறியீட்டின் காலம் முடிந்தது. புதிய குறியீட்டைக் கோரவும்.",
  otpNotFound:
    "சரிபார்ப்புக் குறியீடு கிடைக்கவில்லை. புதிய குறியீட்டைக் கோரவும்.",
  otpVerifyFailed:
    "ஓடிபி (OTP) ஐ சரிபார்க்க முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
  otpSendFailed: "ஓடிபி (OTP) ஐ அனுப்ப முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
  consentConfirmed: "ஒப்புதல் உறுதி செய்யப்பட்டது",
  recordedUnder:
    "ஓடிபி (OTP) சரிபார்க்கப்பட்டது · {regulation} இன் கீழ் பதிவு செய்யப்பட்டது",
  recordedUnderAt:
    "ஓடிபி (OTP) சரிபார்க்கப்பட்டது · {regulation} இன் கீழ் {time} மணிக்கு பதிவு செய்யப்பட்டது",
  consentReferenceId: "ஒப்புதல் குறிப்பு ஐடி",
  proceed: "தொடரவும்",
  loadingNotice: "அறிவிப்பு ஏற்றப்படுகிறது",
  loadFailedTitle: "ஒப்புதல் அறிவிப்பை ஏற்ற முடியவில்லை",
  tryAgain: "மீண்டும் முயற்சிக்கவும்.",
  close: "மூடு",
};

const te: StaticStrings = {
  useEmailInstead: "ఇమెయిల్ ఉపయోగించండి",
  useMobileInstead: "మొబైల్ ఉపయోగించండి",
  emailAddress: "ఇమెయిల్ చిరునామా",
  otpHelperEmail: "మేము ఈ ఇమెయిల్‌కు ఒక్కసారి ఉపయోగించే పాస్‌వర్డ్‌ను పంపుతాము.",
  changeEmail: "ఇమెయిల్ మార్చు",
  expandDetails: "{name} వివరాలను విస్తరించు",
  collapseDetails: "{name} వివరాలను కుదించు",
  selectAllFor: "{name} కోసం అన్ని డేటా అంశాలను ఎంచుకోండి",
  selectElement: "{name} ఎంచుకోండి",
  selectElementRequired: "{name} ఎంచుకోండి (అవసరం)",
  required: "అవసరం",
  logoAlt: "లోగో",
  selectLanguage: "భాష ఎంచుకోండి",
  selectLanguageCurrent: "భాష ఎంచుకోండి. ప్రస్తుత భాష: {lang}",
  opensInNewTab: "కొత్త ట్యాబ్‌లో తెరుచుకుంటుంది",
  audioStart: "ఆడియో ప్లేబ్యాక్ ప్రారంభించు",
  audioPause: "ఆడియో ప్లేబ్యాక్ నిలిపివేయి",
  talkbackStart: "టాక్‌బ్యాక్ ప్రారంభించు",
  talkbackPause: "టాక్‌బ్యాక్ నిలిపివేయి",
  mobileNumber: "మొబైల్ నంబర్",
  otpHelper: "మేము ఈ నంబర్‌కు ఒక్కసారి ఉపయోగించే పాస్‌వర్డ్‌ను పంపుతాము.",
  otpSentTo: "ఓటీపీ (OTP) పంపబడింది",
  changeMobile: "మొబైల్ నంబర్ మార్చు",
  enterNDigitOtp: "{count}-అంకెల ఓటీపీ (OTP) నమోదు చేయండి",
  otpDigit: "ఓటీపీ (OTP) అంకె {index}",
  resendIn: "{seconds} సెకన్లలో ఓటీపీ (OTP) మళ్లీ పంపు",
  sending: "పంపుతోంది…",
  resendOtp: "ఓటీపీ (OTP) మళ్లీ పంపు",
  getOtp: "ఓటీపీ (OTP) పొందండి",
  verifying: "ధృవీకరిస్తోంది…",
  verifyOtp: "ఓటీపీ (OTP) ధృవీకరించండి",
  sendOtp: "ఓటీపీ (OTP) పంపండి",
  confirmOtp: "ఓటీపీ (OTP) నిర్ధారించండి",
  verifyWithOtp: "ఓటీపీ (OTP) ద్వారా ధృవీకరించండి",
  editSelections: "ఎంపికలను సవరించండి",
  otpIncorrect:
    "మీరు నమోదు చేసిన ధృవీకరణ కోడ్ తప్పు. దయచేసి తనిఖీ చేసి మళ్లీ ప్రయత్నించండి.",
  otpExpired: "మీ ధృవీకరణ కోడ్ గడువు ముగిసింది. దయచేసి కొత్త కోడ్ అడగండి.",
  otpNotFound: "ధృవీకరణ కోడ్ కనుగొనబడలేదు. దయచేసి కొత్త కోడ్ అడగండి.",
  otpVerifyFailed:
    "ఓటీపీ (OTP) ధృవీకరించడం సాధ్యం కాలేదు. దయచేసి మళ్లీ ప్రయత్నించండి.",
  otpSendFailed: "ఓటీపీ (OTP) పంపడం సాధ్యం కాలేదు. దయచేసి మళ్లీ ప్రయత్నించండి.",
  consentConfirmed: "సమ్మతి నిర్ధారించబడింది",
  recordedUnder:
    "ఓటీపీ (OTP) ధృవీకరించబడింది · {regulation} కింద నమోదు చేయబడింది",
  recordedUnderAt:
    "ఓటీపీ (OTP) ధృవీకరించబడింది · {regulation} కింద {time}కి నమోదు చేయబడింది",
  consentReferenceId: "సమ్మతి సూచన ఐడీ",
  proceed: "కొనసాగించు",
  loadingNotice: "నోటీసు లోడ్ అవుతోంది",
  loadFailedTitle: "సమ్మతి నోటీసును లోడ్ చేయడం సాధ్యం కాలేదు",
  tryAgain: "దయచేసి మళ్లీ ప్రయత్నించండి.",
  close: "మూసివేయి",
};

const ur: StaticStrings = {
  useEmailInstead: "ای میل استعمال کریں",
  useMobileInstead: "موبائل استعمال کریں",
  emailAddress: "ای میل پتہ",
  otpHelperEmail: "ہم اس ای میل پر ایک بار استعمال ہونے والا پاس ورڈ بھیجیں گے۔",
  changeEmail: "ای میل تبدیل کریں",
  expandDetails: "{name} کی تفصیلات پھیلائیں",
  collapseDetails: "{name} کی تفصیلات سمیٹیں",
  selectAllFor: "{name} کے لیے تمام ڈیٹا عناصر منتخب کریں",
  selectElement: "{name} منتخب کریں",
  selectElementRequired: "{name} منتخب کریں (لازمی)",
  required: "لازمی",
  logoAlt: "لوگو",
  selectLanguage: "زبان منتخب کریں",
  selectLanguageCurrent: "زبان منتخب کریں۔ موجودہ زبان: {lang}",
  opensInNewTab: "نئے ٹیب میں کھلتا ہے",
  audioStart: "آڈیو پلے بیک شروع کریں",
  audioPause: "آڈیو پلے بیک روکیں",
  talkbackStart: "ٹاک بیک شروع کریں",
  talkbackPause: "ٹاک بیک روکیں",
  mobileNumber: "موبائل نمبر",
  otpHelper: "ہم اس نمبر پر ایک بار استعمال ہونے والا پاس ورڈ بھیجیں گے۔",
  otpSentTo: "او ٹی پی (OTP) بھیج دیا گیا",
  changeMobile: "موبائل نمبر تبدیل کریں",
  enterNDigitOtp: "{count}-ہندسوں والا او ٹی پی (OTP) درج کریں",
  otpDigit: "او ٹی پی (OTP) ہندسہ {index}",
  resendIn: "{seconds} سیکنڈ میں او ٹی پی (OTP) دوبارہ بھیجیں",
  sending: "بھیجا جا رہا ہے…",
  resendOtp: "او ٹی پی (OTP) دوبارہ بھیجیں",
  getOtp: "او ٹی پی (OTP) حاصل کریں",
  verifying: "تصدیق ہو رہی ہے…",
  verifyOtp: "او ٹی پی (OTP) کی تصدیق کریں",
  sendOtp: "او ٹی پی (OTP) بھیجیں",
  confirmOtp: "او ٹی پی (OTP) کی تصدیق کریں",
  verifyWithOtp: "او ٹی پی (OTP) سے تصدیق کریں",
  editSelections: "انتخاب میں ترمیم کریں",
  otpIncorrect:
    "آپ کا درج کردہ توثیقی کوڈ غلط ہے۔ براہ کرم جانچیں اور دوبارہ کوشش کریں۔",
  otpExpired:
    "آپ کے توثیقی کوڈ کی میعاد ختم ہو گئی ہے۔ براہ کرم نیا کوڈ طلب کریں۔",
  otpNotFound: "توثیقی کوڈ نہیں ملا۔ براہ کرم نیا کوڈ طلب کریں۔",
  otpVerifyFailed:
    "او ٹی پی (OTP) کی تصدیق نہیں ہو سکی۔ براہ کرم دوبارہ کوشش کریں۔",
  otpSendFailed: "او ٹی پی (OTP) نہیں بھیجا جا سکا۔ براہ کرم دوبارہ کوشش کریں۔",
  consentConfirmed: "رضامندی کی تصدیق ہو گئی",
  recordedUnder:
    "او ٹی پی (OTP) تصدیق شدہ · {regulation} کے تحت ریکارڈ کیا گیا",
  recordedUnderAt:
    "او ٹی پی (OTP) تصدیق شدہ · {regulation} کے تحت {time} پر ریکارڈ کیا گیا",
  consentReferenceId: "رضامندی ریفرنس آئی ڈی",
  proceed: "آگے بڑھیں",
  loadingNotice: "نوٹس لوڈ ہو رہا ہے",
  loadFailedTitle: "رضامندی نوٹس لوڈ نہیں ہو سکا",
  tryAgain: "براہ کرم دوبارہ کوشش کریں۔",
  close: "بند کریں",
};

const as: StaticStrings = {
  useEmailInstead: "ইমেইল ব্যৱহাৰ কৰক",
  useMobileInstead: "মোবাইল ব্যৱহাৰ কৰক",
  emailAddress: "ইমেইল ঠিকনা",
  otpHelperEmail: "আমি এই ইমেইললৈ এটা এবাৰ ব্যৱহাৰযোগ্য পাছৱৰ্ড পঠিয়াম।",
  changeEmail: "ইমেইল সলনি কৰক",
  expandDetails: "{name} ৰ বিৱৰণ বিস্তাৰ কৰক",
  collapseDetails: "{name} ৰ বিৱৰণ সংকোচন কৰক",
  selectAllFor: "{name} ৰ বাবে সকলো ডাটা উপাদান বাছনি কৰক",
  selectElement: "{name} বাছনি কৰক",
  selectElementRequired: "{name} বাছনি কৰক (আৱশ্যক)",
  required: "আৱশ্যক",
  logoAlt: "ল’গো",
  selectLanguage: "ভাষা বাছনি কৰক",
  selectLanguageCurrent: "ভাষা বাছনি কৰক। বৰ্তমানৰ ভাষা: {lang}",
  opensInNewTab: "নতুন টেবত খোলে",
  audioStart: "অডিঅ’ প্লেবেক আৰম্ভ কৰক",
  audioPause: "অডিঅ’ প্লেবেক বিৰতি দিয়ক",
  talkbackStart: "টকবেক আৰম্ভ কৰক",
  talkbackPause: "টকবেক বিৰতি দিয়ক",
  mobileNumber: "মোবাইল নম্বৰ",
  otpHelper: "আমি এই নম্বৰলৈ এটা এবাৰ ব্যৱহাৰযোগ্য পাছৱৰ্ড পঠিয়াম।",
  otpSentTo: "ওটিপি (OTP) পঠিওৱা হ’ল",
  changeMobile: "মোবাইল নম্বৰ সলনি কৰক",
  enterNDigitOtp: "{count}-অংকৰ ওটিপি (OTP) দিয়ক",
  otpDigit: "ওটিপি (OTP) অংক {index}",
  resendIn: "{seconds} ছেকেণ্ডত ওটিপি (OTP) পুনৰ পঠিয়াওক",
  sending: "পঠিওৱা হৈ আছে…",
  resendOtp: "ওটিপি (OTP) পুনৰ পঠিয়াওক",
  getOtp: "ওটিপি (OTP) লওক",
  verifying: "সত্যাপন কৰি আছে…",
  verifyOtp: "ওটিপি (OTP) সত্যাপন কৰক",
  sendOtp: "ওটিপি (OTP) পঠিয়াওক",
  confirmOtp: "ওটিপি (OTP) নিশ্চিত কৰক",
  verifyWithOtp: "ওটিপি (OTP) ৰে সত্যাপন কৰক",
  editSelections: "বাছনিসমূহ সম্পাদনা কৰক",
  otpIncorrect:
    "আপুনি দিয়া সত্যাপন ক'ড ভুল। অনুগ্ৰহ কৰি পৰীক্ষা কৰি পুনৰ চেষ্টা কৰক।",
  otpExpired: "আপোনাৰ সত্যাপন ক'ডৰ ম্যাদ উকলিল। অনুগ্ৰহ কৰি নতুন ক'ড বিচাৰক।",
  otpNotFound: "সত্যাপন ক'ড পোৱা নগ'ল। অনুগ্ৰহ কৰি নতুন ক'ড বিচাৰক।",
  otpVerifyFailed:
    "ওটিপি (OTP) সত্যাপন কৰিব পৰা নগ'ল। অনুগ্ৰহ কৰি পুনৰ চেষ্টা কৰক।",
  otpSendFailed: "ওটিপি (OTP) পঠিয়াব পৰা নগ'ল। অনুগ্ৰহ কৰি পুনৰ চেষ্টা কৰক।",
  consentConfirmed: "সন্মতি নিশ্চিত হ’ল",
  recordedUnder: "ওটিপি (OTP) সত্যাপিত · {regulation} ৰ অধীনত লিপিবদ্ধ কৰা হ’ল",
  recordedUnderAt:
    "ওটিপি (OTP) সত্যাপিত · {regulation} ৰ অধীনত {time} বজাত লিপিবদ্ধ কৰা হ’ল",
  consentReferenceId: "সন্মতি ৰেফাৰেন্স আইডি",
  proceed: "আগবাঢ়ক",
  loadingNotice: "জাননী ল’ড হৈ আছে",
  loadFailedTitle: "সন্মতি জাননী ল’ড কৰিব পৰা নগ’ল",
  tryAgain: "অনুগ্ৰহ কৰি পুনৰ চেষ্টা কৰক।",
  close: "বন্ধ কৰক",
};

const brx: StaticStrings = {
  useEmailInstead: "इमेल बाहाय",
  useMobileInstead: "मबाइल बाहाय",
  emailAddress: "इमेल ठिकानाय",
  otpHelperEmail: "जों बे इमेलआव मोनसे थांखि बाहायनाय पासवार्ड दैथायगोन।",
  changeEmail: "इमेल सोलायहो",
  expandDetails: "{name} नि गुवारै बेखेवनाय खालामो",
  collapseDetails: "{name} नि गुवारै फुंखानाय खालामो",
  selectAllFor: "{name} नि थाखाय गासै डाटा बिथिं सायख",
  selectElement: "{name} सायख",
  selectElementRequired: "{name} सायख (गोनां)",
  required: "गोनां",
  logoAlt: "लोगो",
  selectLanguage: "राव सायख",
  selectLanguageCurrent: "राव सायख। दानि राव: {lang}",
  opensInNewTab: "गोदान टेबआव खेवनाय जायो",
  audioStart: "अडिअ' प्लेबेक जागायहो",
  audioPause: "अडिअ' प्लेबेक थिनाय खालामो",
  talkbackStart: "टकबेक जागायहो",
  talkbackPause: "टकबेक थिनाय खालामो",
  mobileNumber: "मबाइल नम्बर",
  otpHelper: "जों बे नम्बरआव मोनसे थांखि बाहायनाय पासवार्ड दैथायगोन।",
  otpSentTo: "ओटीपी (OTP) दैथायबाय",
  changeMobile: "मबाइल नम्बर सोलायहो",
  enterNDigitOtp: "{count}-अंकनि ओटीपी (OTP) हाबहो",
  otpDigit: "ओटीपी (OTP) अंक {index}",
  resendIn: "{seconds} सेकेन्डआव ओटीपी (OTP) फिन दैथाय",
  sending: "दैथायगासिनो दं…",
  resendOtp: "ओटीपी (OTP) फिन दैथाय",
  getOtp: "ओटीपी (OTP) मोनो",
  verifying: "रोखा खालामगासिनो दं…",
  verifyOtp: "ओटीपी (OTP) रोखा खालामो",
  sendOtp: "ओटीपी (OTP) दैथाय",
  confirmOtp: "ओटीपी (OTP) पोखा खालामो",
  verifyWithOtp: "ओटीपी (OTP) जों रोखा खालामो",
  editSelections: "सायखनायखौ सुजुहो",
  otpIncorrect:
    "नोंथाङा हाबहोनाय सत्यापन कोडआ गोरोबा नङा। अननानै नाजावनानै फिन नाजा।",
  otpExpired: "नोंथांनि सत्यापन कोडनि सम जोबबाय। अननानै गोदान कोड बिथां।",
  otpNotFound: "सत्यापन कोड मोनाखै। अननानै गोदान कोड बिथां।",
  otpVerifyFailed: "ओटीपी (OTP) रोखा खालामनो हायाखै। अननानै फिन नाजा।",
  otpSendFailed: "ओटीपी (OTP) दैथायनो हायाखै। अननानै फिन नाजा।",
  consentConfirmed: "रायजुमनाय रोखा जाबाय",
  recordedUnder: "ओटीपी (OTP) रोखा जाबाय · {regulation} नि सिङाव लिरनाय जादों",
  recordedUnderAt:
    "ओटीपी (OTP) रोखा जाबाय · {regulation} नि सिङाव {time} आव लिरनाय जादों",
  consentReferenceId: "रायजुमनाय रेफरेन्स आइडि",
  proceed: "सिगांआव थां",
  loadingNotice: "नोटिस लोड जागासिनो दं",
  loadFailedTitle: "रायजुमनाय नोटिस लोड खालामनो हायाखै",
  tryAgain: "अननानै फिन नाजा।",
  close: "बन्द खालामो",
};

const doi: StaticStrings = {
  useEmailInstead: "ईमेल बरतो",
  useMobileInstead: "मोबाइल बरतो",
  emailAddress: "ईमेल पता",
  otpHelperEmail: "अस इस ईमेल पर इक बारी बरतोने आह्ला पासवर्ड भेजगे।",
  changeEmail: "ईमेल बदलो",
  expandDetails: "{name} दा विवरण फैलाओ",
  collapseDetails: "{name} दा विवरण समेटो",
  selectAllFor: "{name} आस्तै सब्भै डेटा तत्व चुनो",
  selectElement: "{name} चुनो",
  selectElementRequired: "{name} चुनो (लोड़चदा)",
  required: "लोड़चदा",
  logoAlt: "लोगो",
  selectLanguage: "भाशा चुनो",
  selectLanguageCurrent: "भाशा चुनो। मजूदा भाशा: {lang}",
  opensInNewTab: "नमें टैब च खुल्लदा ऐ",
  audioStart: "ऑडियो प्लेबैक शुरू करो",
  audioPause: "ऑडियो प्लेबैक रोको",
  talkbackStart: "टॉकबैक शुरू करो",
  talkbackPause: "टॉकबैक रोको",
  mobileNumber: "मोबाइल नंबर",
  otpHelper: "अस इस नंबर पर इक बारी बरतोने आह्ला पासवर्ड भेजगे।",
  otpSentTo: "ओटीपी (OTP) भेजेआ गेआ",
  changeMobile: "मोबाइल नंबर बदलो",
  enterNDigitOtp: "{count}-अंकें दा ओटीपी (OTP) पाओ",
  otpDigit: "ओटीपी (OTP) अंक {index}",
  resendIn: "{seconds} सकिंटें च ओटीपी (OTP) फ्ही भेजो",
  sending: "भेजेआ जा करदा ऐ…",
  resendOtp: "ओटीपी (OTP) फ्ही भेजो",
  getOtp: "ओटीपी (OTP) हासल करो",
  verifying: "तसदीक कीती जा करदी ऐ…",
  verifyOtp: "ओटीपी (OTP) दी तसदीक करो",
  sendOtp: "ओटीपी (OTP) भेजो",
  confirmOtp: "ओटीपी (OTP) दी पुष्टी करो",
  verifyWithOtp: "ओटीपी (OTP) कन्नै तसदीक करो",
  editSelections: "चोनें गी बदलो",
  otpIncorrect:
    "तुसें दर्ज कीता तसदीक कोड गलत ऐ। किरपा करियै जाँच करो ते फ्ही कोशिश करो।",
  otpExpired:
    "तुंदे तसदीक कोड दी मीयाद खत्म होई गेई ऐ। किरपा करियै नमां कोड मंगो।",
  otpNotFound: "तसदीक कोड नेईं मिलेआ। किरपा करियै नमां कोड मंगो।",
  otpVerifyFailed:
    "ओटीपी (OTP) दी तसदीक नेईं होई सकी। किरपा करियै फ्ही कोशिश करो।",
  otpSendFailed: "ओटीपी (OTP) नेईं भेजेआ जाई सकेआ। किरपा करियै फ्ही कोशिश करो।",
  consentConfirmed: "सहमति दी पुष्टी होई",
  recordedUnder: "ओटीपी (OTP) तसदीकशुदा · {regulation} दे तहत दर्ज कीता गेआ",
  recordedUnderAt:
    "ओटीपी (OTP) तसदीकशुदा · {regulation} दे तहत {time} पर दर्ज कीता गेआ",
  consentReferenceId: "सहमति रैफरैंस आईडी",
  proceed: "अग्गें बधो",
  loadingNotice: "नोटिस लोड होआ करदा ऐ",
  loadFailedTitle: "सहमति नोटिस लोड नेईं होई सकेआ",
  tryAgain: "किरपा करियै फ्ही कोशिश करो।",
  close: "बंद करो",
};

export const STATIC_STRINGS: Record<string, StaticStrings> = {
  en,
  hi,
  bn,
  gu,
  kn,
  ks,
  gom,
  mai,
  ml,
  "mni-Mtei": mniMtei,
  mr,
  ne,
  or,
  pa,
  sa,
  sat,
  sd,
  ta,
  te,
  ur,
  as,
  brx,
  doi,
};

const interpolate = (template: string, vars?: StaticVars): string =>
  vars
    ? template.replace(/\{(\w+)\}/g, (match, token) =>
        token in vars ? String(vars[token]) : match,
      )
    : template;

export const makeStaticT =
  (langCode: string) =>
  (key: StaticKey, vars?: StaticVars): string => {
    const table = STATIC_STRINGS[langCode] ?? en;
    const template = table[key] ?? en[key];
    return interpolate(template, vars);
  };
